import axios from "axios";

export default class Api {
    static getAppConfig() {
        const url = process.env.VUE_APP_BACKEND_URL + '/getAppConfig';
        return axios.get(url)
    }

    static getCurrentUser() {
        const url = process.env.VUE_APP_BACKEND_URL + '/userinfo/current';
        return axios.get(url)
    }

    static getEnvProfile() {
        const url = process.env.VUE_APP_BACKEND_URL + '/profile';
        return axios.get(url)
    }

    static getMyJWTToken(username) {
        const url = process.env.VUE_APP_BACKEND_URL + '/getMyJWTToken';
        return axios.get(url, {
            params: {
                username: username
            }
        });
    }

    static logoutUser() {
        const url = process.env.VUE_APP_BACKEND_URL + '/logoutUser';
        return axios.post(url);
    }
    ///////////////////////////

    // 2FA
    static getTwoFactorAuthCode(username, password) {
        const url = process.env.VUE_APP_BACKEND_URL + '/getTwoFactorAuthCode';
        return axios.get(url, {
            params: {
                username: username,
                password: password
            }
        });
    }
    static login2FA(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/login2FA';
        return axios.post(url, params);
    }
    ///////////////////////////

    // User edit
    static editUserDetails(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/users/changeData';
        return axios.put(url, params)
    }

    // Forgot password
    static forgotPassword(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/forgotPassword';
        return axios.post(url, params)
    }
    /////////////////////

    // Address
    static getAddressById(addressId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient/getPatientAddressObjById?patientAddressId=' + addressId;
        return axios.get(url);
    }
    static getCountryOptions(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/country';
        return axios.get(url, params);
    }
    static getCountryExtendedOptions(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/country/extended';
        return axios.get(url, params);
    }
    static getZipOptions(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/city/zip';
        return axios.get(url, params);
    }
    static getCountyById(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/county/' + id;
        return axios.get(url);
    }
    static getCitiesByCountryIdZipName(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/city/byCountryZipName';
        return axios.get(url, params);
    }
    static listRegionsForSelect() {
        const url = process.env.VUE_APP_BACKEND_URL + '/county/listRegionsForSelect';
        return axios.get(url);
    }

    /////////////////////

    // Licence Management
    static getLicenceManagement() {
        const url = process.env.VUE_APP_BACKEND_URL + '/licenceManagement';
        return axios.get(url);
    }
    static saveLicenceManagement(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/licenceManagement';
        return axios.put(url, params);
    }
    /////////////////////
    // EditorWithTag - adding new tags
    // static addNewTagsForInput(params) {
    //     const url = process.env.VUE_APP_BACKEND_URL + '/valami';
    //     return axios.post(url, params);
    // }

    // Country, county, city
    static getAllCountyToSelect(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/county';
        return axios.get(url, params);
    }
    static getAllHungaryCountyToSelect() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/extended/countyCodes/' + 30020;
        return axios.get(url);
    }
    static getAllCountries(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/country/listByPaging';
        return axios.get(url, params);
    }
    static getAllCounties(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/county/listByPaging';
        return axios.get(url, params);
    }
    static getAllCities(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/city/listByPaging';
        return axios.get(url, params);
    }
    static saveCountry(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/country';
            return axios.put(url, params)
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/country';
            return axios.post(url, params)
        }
    }
    static deleteCountry(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/country?id=' + id;
        return axios.delete(url);
    }
    static saveCounty(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/county';
            return axios.put(url, params)
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/county';
            return axios.post(url, params)
        }
    }
    static deleteCounty(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/county?id=' + id;
        return axios.delete(url);
    }
    static saveCity(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/city';
            return axios.put(url, params)
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/city';
            return axios.post(url, params)
        }
    }
    static deleteCity(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/city?id=' + id;
        return axios.delete(url);
    }
    /////////////////////

    // Code store
    static getCodeStoreCrudApiCallback(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore';
        return axios.get(url, params);
    }
    static saveCodeStore(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore';
        return axios.post(url, params);
    }
    static modifyCodeStore(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/' + params.oldId;
        return axios.put(url, params);
    }
    static deleteCodeStore(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore?id=' + id;
        return axios.delete(url);
    }
    static getAllCodeStoreSimple() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/withoutType';
        return axios.get(url);
    }
    static saveCodeStoreSimple(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/insertSimple';
        return axios.post(url, params);
    }
    static getCodeStoreByTpye() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=-1';
        return axios.get(url);
    }
    static getStatusCodes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/byType?csId=24';
        return axios.get(url);
    }
    static getHealthDamageId() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=50100';
        return axios.get(url);
    }
    static getLabPackageTypes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=14';
        return axios.get(url);
    }
    static getInternalReferralStatus() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=153200';
        return axios.get(url);
    }
    static getStatusesForExamination() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=161000';
        return axios.get(url);
    }

    ////////////////////

    // Code Store Extended
    static getAllCodeStoreExtended(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/extended';
        return axios.get(url, params);
    }
    static saveCodeStoreExtended(params) {
        if (params.oldId) {
            const url = process.env.VUE_APP_BACKEND_URL + '/cstore/extended/' + params.oldId;
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/cstore/extended';
            return axios.post(url, params);
        }
    }
    static deleteCodeStoreExtended(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/extended?id=' + id;
        return axios.delete(url);
    }
    ////////////////////

    // Company site
    static getAllCompanySite(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/companySite?withdeleted=true';
        return axios.get(url, params);
    }
    static getAllActiveCompanySite() {
        const url = process.env.VUE_APP_BACKEND_URL + '/companySite/selectActives';
        return axios.get(url);
    }
    static saveCompanySite(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/companySite/' + params.id;
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/companySite';
            return axios.post(url, params);
        }
    }
    static deactivateCompanySite(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/companySite/deactivateCompanySite/' + id;
        return axios.post(url);
    }
    static deleteCompanySite(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/companySite?id=' + id;
        return axios.delete(url);
    }
    static getCompanySiteById(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/companySite/' + id;
        return axios.get(url);
    }
    static getCompanySitesByDoctorId(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/companySite/getByDoctorId';
        return axios.get(url, params);
    }
    static getCompanySitesByHrFeeId(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/companySite/getByHrFeeId?humanResourceFeeId=' + id;
        return axios.get(url);
    }
    static getCompanySiteToCheckboxes(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/companySite/getByCompanyId';
        return axios.get(url, params);
    }

    ////////////////////

    // Logins
    static getAllLogins(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/loginUser/listByPaging';
        return axios.get(url, params);
    }
    static getWeeklyLoginTraffic(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/loginUser/listByWeek';
        return axios.get(url, params);
    }
    ////////////////////

    // User
    static getUserCrudApiCallback(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/users';
        return axios.get(url, params);
    }
    static getUserDetails(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/users/' + id;
        return axios.get(url);
    }
    static deleteUser(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/users?id=' + id;
        return axios.delete(url);
    }
    static unDeleteUser(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/users/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static saveUser(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/users';
            return axios.put(url, params);
        }
        else {
            const url = process.env.VUE_APP_BACKEND_URL + '/users';
            return axios.post(url, params);
        }
    }
    static getAllRoleApiCallback(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/roles';
        return axios.get(url, params);
    }
    static getUserById(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/users/' + id;
        return axios.get(url);
    }
    static savePacsForUser(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/users/savePacsUsernameAndPassword';
        return axios.post(url, params);
    }
    ////////////////////

    // Logs
    static getAllLogs(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/logs/getLogFileList';
        return axios.get(url, params);
    }

    static getLogFile(param) {
        const url = process.env.VUE_APP_BACKEND_URL + '/logs/getLogFile/' + param;
        return axios.get(url);
    }

    static getMedioLogFiles(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medio-log/listByPaging';
        return axios.get(url, params);
    }
    ////////////////////

    // Email view
    static getAllEmailView(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/emailView/listByPaging';
        return axios.get(url, params);
    }
    static getAllEmailReport(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/emailView/report/listByPaging';
        return axios.get(url, params);
    }
    ////////////////////

    // Metrics
    static getEnvProperties() {
        const url = process.env.VUE_APP_BACKEND_URL + '/metrics/env';
        // const url = process.env.VUE_APP_BACKEND_URL + '/actuator/env';
        return axios.get(url);
    }
    static getLiquibaseProperties() {
        const url = process.env.VUE_APP_BACKEND_URL + '/actuator/liquibase';
        return axios.get(url);
    }

    static getHwProperties() {
        const url = process.env.VUE_APP_BACKEND_URL + '/metrics/system';
        return axios.get(url);
    }

    static getJvmMetricProperties() {
        const url = process.env.VUE_APP_BACKEND_URL + '/actuator/metrics';
        return axios.get(url);
    }

    static getJvmMetricProperty(property) {
        const url = process.env.VUE_APP_BACKEND_URL + '/actuator/metrics/' + property;
        return axios.get(url);
    }

    static getHealthProperties() {
        const url = process.env.VUE_APP_BACKEND_URL + '/actuator/health';
        return axios.get(url);
    }
    ////////////////////

    // Email template editor
    static getAllTemplate(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/emailEditor';
        return axios.get(url, params);
    }
    static getPartnerEmailTemplates() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partner/getTemplateOptions';
        return axios.get(url);
    }
    static getPartnerTemplateById(partnerId, templateId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partner/getTemplateByType?partnerId=' + partnerId + '&typeId=' + templateId;
        return axios.get(url);
    }

    static saveEmailTemplate(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/emailEditor';
        return axios.put(url, params);
    }
    static savePartnerEmailTemplate(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partner/updatePartnerTemplate';
        return axios.post(url, params);
    }

    static getEmailTemplateByTreatmentId(treatmentId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/treatmentType/byTreatmentTypeId/' + treatmentId;
        return axios.get(url);
    }
    ////////////////////

    // Doctor template
    static getAllDoctorTemplate(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorTemplate';
        return axios.get(url, params);
    }
    static modifyDoctorTemplate(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorTemplate';
        return axios.put(url, params);
    }
    static saveDoctorTemplate(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorTemplate';
        return axios.post(url, params);
    }
    static deleteDoctorTemplate(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorTemplate?id=' + id;
        return axios.delete(url);
    }
    static undeleteDoctorTemplate(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorTemplate/setUnDelete?id=' + id;
        return axios.post(url);
    }

    static getAllClinic() {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorTemplate/clinic';
        return axios.get(url);
    }

    static getAllTemplateType() {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorTemplate/templateType';
        return axios.get(url);
    }
    ////////////////////

    // Appointment history
    static getAllHistMedAppointment(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointmentsHistory/listByPaging';
        return axios.get(url, params);
    }
    ////////////////////

    // Appointment ManDoc error
    static getAllAppointmentManDocError(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointmentsManDocError/listByPaging';
        return axios.get(url, params);
    }
    ////////////////////

    // Patient
    static getDocumentTypeOptions(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientSearch/documentType';
        return axios.get(url, params);
    }
    static getDriverLicenseDocumentTypeOptions(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientSearch/documentTypesForDriversLicense';
        return axios.get(url, params);
    }
    static getParnersForAppointment(params) {
        let url
        if (params.params.selectedPartnerId) {
            url = process.env.VUE_APP_BACKEND_URL + '/patientSearch/getParnersForAppointment?selectedPartnerId=' + params.params.selectedPartnerId;
        } else {
            url = process.env.VUE_APP_BACKEND_URL + '/patientSearch/getParnersForAppointment'
        }
        return axios.get(url, params);
    }
    static getSexOptions() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=15400';
        return axios.get(url);
    }
    static getPatientStatus() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=46000';
        return axios.get(url);
    }
    static getPatientInfo(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient/select-patient/' + id;
        return axios.get(url);
    }
    static getAllPatientToCheckboxes(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient/toSelect';
        return axios.get(url, params);
    }
    static getAllPatient(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient/listByPaging';
        return axios.post(url, params);
    }
    static getAllPatientToSelect() {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient/getNameWithId';
        return axios.get(url);
    }
    static getAllOPatient(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient/listOccupationHealthPatientsByPaging';
        return axios.post(url, params);
    }
    static savePatient(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/patient';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/patient';
            return axios.post(url, params);
        }
    }
    static checkSamePatients(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient/checkSamePatients';
        return axios.post(url, params);
    }
    static listSamePatients(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient/listSamePatients';
        return axios.get(url, params);
    }
    static modifyPatient(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient';
        return axios.put(url, params);
    }
    static deletePatient(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient?id=' + id;
        return axios.delete(url);
    }
    static unDeletePatient(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static findPatientById(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient/findById/' + id;
        return axios.get(url);
    }
    static hasPatientDocument(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient/findById/' + id;
        return axios.get(url);
    }
    static mergePatients(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientMerge/merge?id=' + params.id;
        return axios.post(url, params.body);
    }
    ////////////////////

    // Stock
    static getAllStock(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/stock';
        return axios.get(url, params);
    }
    static saveStock(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/stock';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/stock';
            return axios.post(url, params);
        }
    }
    static deleteStock(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/stock?id=' + id;
        return axios.delete(url);
    }
    static unDeleteStock(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/stock/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static getMaterialInstrumentAmountUnit() {
        const url = process.env.VUE_APP_BACKEND_URL + '/materialInstrument/amountUnit';
        return axios.get(url);
    }
    ////////////////////

    // Doctor daily attendance
    static getDailyAttendanceByDoctor(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/listOfAppointmentsForDoctorAttendance';
        return axios.post(url, params);
    }
    ////////////////////

    // BNO
    /**
     * Az összes BNO kódot visszaadja (valid + invalid)
     * @param params
     * @returns {AxiosPromise<any>}
     */
    static getAllBno(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/bno/listByPaging';
        return axios.get(url, params);
    }

    /**
     * Csak azokat a BNO kódokat adja vissza, amik validak
     * @param params (filterbe valid: true)
     * @returns {AxiosPromise<any>}
     */
    static getAllValidBno(params) {
        params.params.filter.valid = true;
        const url = process.env.VUE_APP_BACKEND_URL + '/bno/listByPaging';
        return axios.get(url, params);
    }

    /**
     * Csak azokat a BNO kódokat adja vissza, amik nem validak
     * @param params (filterbe valid: false)
     * @returns {AxiosPromise<any>}
     */
    static getAllInvalidBno(params) {
        params.params.filter.valid = false;
        const url = process.env.VUE_APP_BACKEND_URL + '/bno/listByPaging';
        return axios.get(url, params);
    }
    static getBnoByKod(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/bno/getBnoByKod';
        return axios.get(url, params);
    }
    static saveBno(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/bno';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/bno';
            return axios.post(url, params);
        }
    }
    static deleteBno(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/bno?id=' + id;
        return axios.delete(url);
    }
    static unDeleteBno(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/bno/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static getBnoForSelect(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/bno/bnoFilter';
        return axios.get(url, params);
    }
    static getBnoListForTagComponent(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/bno/listByPagingForTag';
        return axios.get(url, params);
    }
    ////////////////////

    // Drug
    static getAllDrugPerjelRequired(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/drugs/listByPaging';
        params.params.filter.isPerjelRequired = true;
        return axios.get(url, params);
    }

    static getAllDrug(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/drugs/listByPaging';
        return axios.get(url, params);
    }

    static getEquivalentDrug(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/drugs/getEquivalentDrugs';
        return axios.get(url, params);
    }

    static getSupportGroupDrug(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/drugs/getSupportGroupDrug';
        return axios.get(url, params);
    }

    static getNicheByEgyenId(egyenId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/drugs/getNicheByEgyenId/' + egyenId;
        return axios.get(url);
    }

    static getBnoCodesByDrugId(drugId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/drugs/getIcdCodes/' + drugId;
        return axios.get(url);
    }
    ////////////////////

    // Drug strain archive
    static getAllDrugArchive(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/drugStrainArchive/drugs/listByPaging';
        return axios.get(url, params);
    }
    static getBnoCodesArchiveByDrugId(fileName, drugId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/drugStrainArchive/drugs/getIcdCodes/' + fileName + '/' + drugId;
        return axios.get(url);
    }
    static getDrugEquivArchiveByDrugId(fileName, drugId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/drugStrainArchive/drugs/getEquivDrugs/' + fileName + '/' + drugId;
        return axios.get(url);
    }
    static getAllBnoArchive(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/drugStrainArchive/bno/listByPaging';
        return axios.get(url, params);
    }
    static getAllMDBFile() {
        const url = process.env.VUE_APP_BACKEND_URL + '/mdbUpload';
        return axios.get(url);
    }
    ////////////////////

    // Patient attendance
    // Appointment
    static getAllAppointment(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientSearch/listByPaging';
        return axios.post(url, params);
    }
    static getContactsToSelect(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientSearch/contact';
        return axios.get(url, params);
    }
    static getAllContactType() {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientSearch/getAllContactType';
        return axios.get(url);
    }
    static getPartnersToSelect() {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientSearch/partner';
        return axios.get(url);
    }
    static getAllPatientAttendanceByPatientId(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/attendance/patient/' + id;
        return axios.get(url);
    }
    static sendPatientDocumentByRow(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/attendance/sendAttendanceDocuments?attendanceId=' + id;
        return axios.get(url);
    }
    static getAllDisbandPatientById(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientSearch/disband?appointmentId=' + id;
        return axios.get(url);
    }
    static patientDisband(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientSearch/disband';
        return axios.put(url, params, {
            headers: {
                'Content-Type': 'application/json',
            }
        })
    }
    static patientDisbandPay(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientSearch/disband/pay';
        return axios.post(url, params, {
            headers: {
                'Content-Type': 'application/json',
            }
        })
    }

    // Alapadatok
    static getPatientDocumentinNewTab(patientId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientDocument/download/' + patientId;
        return axios.get(url)
    }
    static uploadPatientDocument(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientDocument';
        return axios.post(
            url,
            params,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    }
    static getPatientDocument(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientDocument/getDocument/' + id;
        return axios.get(url);
    }

    // Labor
    static sendPatientLabDocument(labId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/userPatientLabs/sendLabDocument/' + labId;
        return axios.get(url);
    }
    static sendPatientLabOldDocument(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/userPatientLabs/sendOldLabDocument';
        return axios.get(url, params);
    }
    static sendLabImmediatelyToSynlab(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/sendLabImmediately?id=' + id;
        return axios.post(url);
    }
    static getSynlabCodes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/getSynlabCodes';
        return axios.get(url);
    }
    static getSynlabCodesForCompanySite() {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/getSynlabCodesForCompanySite';
        return axios.get(url);
    }
    static getSpecialCasesFieldTypes(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/getSynlabSpecialValuesOnInsert';
        return axios.post(url, params);
    }
    static getBEMMeasurementOptions() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/getBemResults';
        return axios.get(url);
    }
    static getCreatininOptions() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/getCreatininResults';
        return axios.get(url);
    }
    // Szakorvosi
    static getPatientEvicence(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientEvidence/patient';
        return axios.get(url, params);
    }
    static getPatientEvidenceList(patientId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientEvidence/list/patient/' + patientId;
        return axios.get(url);
    }
    static sendCurrentEvidence(evidenceId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientEvidence/sendEvidencePdf/' + evidenceId;
        return axios.get(url);
    }
    static getClinicList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientSearch/clinics';
        return axios.get(url, params);
    }
    static getDoctorDocuments(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorTemplate/findByDoctorId?doctorId=' + params.params.doctorId;
        return axios.get(url);
    }
    static getDefaultDoctorDocument() {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorTemplate/getDefaultTemplate';
        return axios.get(url);
    }
    static saveEvidence(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientEvidence';
        return axios.post(url, params);
    }
    static modifyEvidence(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientEvidence';
        return axios.put(url, params);
    }
    static reOpenDocument(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/reOpenDocument';
        return axios.post(url, params);
    }
    static reOpenEmployability(employabilityId, typeId, reason) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/reOpenEmployability?employabilityId=' + employabilityId + '&typeId=' + typeId + '&reOpenReason=' + reason;
        return axios.post(url);
    }
    static validateDocument(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/validateDocument?id=' + id;
        return axios.post(url);
    }
    static uploadEvidenceDocument(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientEvidence/uploadFile';
        return axios.post(
            url,
            params,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    }
    static getEvidenceDocumentsByEvidenceId(evidenceId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientEvidence/listOfFiles/' + evidenceId;
        return axios.get(url);
    }
    static downloadEvidenceDocument(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientEvidence/print/' + id;
        return axios.get(url);
    }
    static downloadEvidenceHistoryDocument(documentId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientEvidence/printHistory?documentId=' + documentId;
        return axios.get(url);
    }
    static downloadEvidenceDocumentDraft(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientEvidence/printDraft';
        return axios.post(url, params);
    }

    static getBnoKodListForEvidence(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientEvidence/getBnoKodList';
        return axios.get(url, params);
    }
    static getMedDocForEvidence(patientEvidenceId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientEvidence/getMedDocForEvidence?patientEvidenceId=' + patientEvidenceId;
        return axios.get(url);
    }
    static getEvidenceHistory(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/getEvidenceHistory';
        return axios.get(url, params);
    }
    static getEmployabilityHistory(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/getEmployabilityHistory';
        return axios.get(url, params);
    }
    static getOpinionHistory(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/getOpinionHistory';
        return axios.get(url, params);
    }
    static deleteCurrentEvidence(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientEvidence/deleteEvidence';
        return axios.post(url, params);
    }
    static unDeleteCurrentEvidence(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientEvidence/restoreEvidence';
        return axios.post(url, params);
    }
    static rollbackEvidenceVersion(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/rollbackEvidenceVersion?documentId=' + id;
        return axios.post(url);
    }
    static rollbacEmployabilityVersion(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/rollbackEmployability?documentId=' + id;
        return axios.post(url);
    }
    static getPatientEvidenceNonValidatedDocuments(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientEvidence/listDraftEvidences';
        return axios.get(url, params);
    }
    static getEmployabilityNonValidatedDocuments(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/occupationHealthEmployability/findAllDraftEmployability';
        return axios.get(url, params);
    }
    static getOccupationHealthPatientEvidenceNonValidatedDocuments(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientEvidence/listDraftFEUEvidences';
        return axios.get(url, params);
    }
    //Tételek felkódolása
    static saveCodingTreatments(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-coding-treatment/save';
        return axios.put(url, params);
    }
    static saveWithoutCoding(appointmentId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-coding-treatment/saveWithoutCoding?appointmentId=' + appointmentId;
        return axios.post(url);
    }

    static getTreatmentTypeName(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/treatmentType/findByTreatmentName?id=' + id;
        return axios.get(url);
    }



    /* static updateCodingTreatments(params) { //ez nincs használva sehol
         const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-coding-treatment/update';
         return axios.post(url, params);
     }*/


    static updateCodingTreatments(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-coding-treatment/update';
        return axios.post(url, params);
    }


    static getSelectedTreatments() {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-coding-treatment/list';
        return axios.get(url);
    }

    // Dokumentumok
    static getEvidenceDocumentByPatientId(patientId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientEvidence/listOfFilesByPatient/' + patientId;
        return axios.get(url);
    }

    //Nem EÜ dokumentumok
    static getNonMedDocumentByPatientId(patientId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientDocument/getDocument/' + patientId;
        return axios.get(url);
    }
    static deleteNonMedDocumentById(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientDocument/delete?id=' + id;
        return axios.delete(url);
    }
    static getDocumentTypes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientDocument/getDocumentTypes';
        return axios.get(url);
    }

    // Tagság
    static getMembershipTypes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientSearch/membershipType';
        return axios.get(url);
    }

    static savePatientMembership(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient/membership';
        return axios.put(url, params);
    }
    ////////////////////

    // Report
    static getWorklistDeliveryNotes(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labType/listSynlabWorklist'
        return axios.get(url, params);
    }
    static getLaborReports(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/labReportListByPaging'
        return axios.post(url, params.params);
    }
    static printWorklistDeliveryNotes(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labType/exportSynlabPdf'
        return axios.get(url, params);
    }

    static getMonthlyPremiumForDoctors(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/report/monthlyPremium';
        return axios.get(url, params);
    }
    static getMonthlyPremiumForDoctorsListByPaging(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/report/monthlyPremiumListByPaging';
        return axios.get(url, params);
    }
    static getMonthlyPremiumForDoctorsSum(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/report/monthlyPremiumSum';
        return axios.get(url, params);
    }

    static getDailyPatientTrafficCount(date) {
        const url = process.env.VUE_APP_BACKEND_URL + '/report/patientTrafficDaily/' + date;
        return axios.get(url);
    }
    static getDailyPatientTraffic(filterDate, interval) {
        const url = process.env.VUE_APP_BACKEND_URL + '/report/groupedTrafficStatistics?filterDate=' + filterDate + '&interval=' + interval;
        return axios.get(url);
    }
    static getWeeklyPatientTrafficCount(date) {
        const url = process.env.VUE_APP_BACKEND_URL + '/report/patientTrafficWeekly/' + date;
        return axios.get(url);
    }
    static getWeeklyPatientTraffic(filterDate, interval) {
        const url = process.env.VUE_APP_BACKEND_URL + '/report/groupedTrafficStatistics?filterDate=' + filterDate + '&interval=' + interval;
        return axios.get(url);
    }

    static getPatientTrafficPerTreatment(dateTime) {
        const url = process.env.VUE_APP_BACKEND_URL + '/report/patientTrafficByTreatment/' + dateTime;
        return axios.get(url);
    }

    static getPatientTrafficPerDoctor(dateTime) {
        const url = process.env.VUE_APP_BACKEND_URL + '/report/patientTrafficByDoctor/' + dateTime;
        return axios.get(url);
    }

    static getWeeklyOldAndNewPatientDistribution(dateTime) {
        const url = process.env.VUE_APP_BACKEND_URL + '/report/oldNewPatientDistributionWeek/' + dateTime;
        return axios.get(url);
    }

    static getMonthlyOldAndNewPatientDistribution(dateTime) {
        const url = process.env.VUE_APP_BACKEND_URL + '/report/oldNewPatientDistributionMonth/' + dateTime;
        return axios.get(url);
    }

    static getRoomUtilization(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/report/roomUtilizationListByPaging'
        return axios.post(url,params);
    }

    static getDoctorUtilization(doctorId, date) {
        const url = process.env.VUE_APP_BACKEND_URL + '/report/getDoctorUtilization/' + doctorId + '/' + date;
        return axios.get(url);
    }

    static findBySiteIdToSelect() {
        const url = process.env.VUE_APP_BACKEND_URL + '/room/findBySiteIdToSelect';
        return axios.get(url);
    }

    static getTreatmentTypesByName() {
        const url = process.env.VUE_APP_BACKEND_URL + '/treatmentType/typeName';
        return axios.get(url);
    }
    static getTreatmentForDoctorWithPackages(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/treatmentType/treatmentForDoctorWithPackages';
        return axios.get(url, params);
    }
    static getTreatmentCount(treatmentId, fromDate, toDate) {
        const url = process.env.VUE_APP_BACKEND_URL + '/report/getTreatmentCount/' + treatmentId + '/' + fromDate + '/' + toDate;
        return axios.get(url);
    }
    static getTreatmentStatisticCount(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/report/getTreatmentStatisticCount';
        return axios.get(url, params);
    }
    static getTreatmentStatisticMedio(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/report/getTreatmentStatisticMedio';
        return axios.get(url, params);
    }
    static getTreatmentStatisticReferrals(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/internalReferral/listReport';
        return axios.get(url, params);
    }
    ////////////////////

    //External Appointments
    static getAllExternalAppointments() {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/unconfirmed';
        return axios.get(url);
    }

    static getExternalAppointmentsCount() {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/unconfirmed/count';
        return axios.get(url);
    }

    static acceptExternalAppointment(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/unconfirmed/approve';
        return axios.post(url, id, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        });
    }
    ////////////////////

    // Drug strain
    static getAllUploadedFiles() {
        const url = process.env.VUE_APP_BACKEND_URL + '/mdbUpload';
        return axios.get(url);
    }

    static uploadMdbfile(param) {
        const url = process.env.VUE_APP_BACKEND_URL + '/mdbUpload/uploadMdb';
        return axios.post(
            url,
            param,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    }

    static loadMdbToDatabase(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/mdbUpload/loadMdbToDatabase';
        return axios.post(url, params);
    }
    ////////////////////

    // Simple Xls loader

    static getAllSimpleXlsFiles(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/simpleXlsLoader/listByPaging';
        return axios.get(url, params);
    }

    static loadSimpleXlsToDatabase(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/simpleXlsLoader/loadXls?id=' + id;
        return axios.post(url);
    }

    static getSimpleXlsLog(param) {
        const url = process.env.VUE_APP_BACKEND_URL + '/simpleXlsLoader/log/listByPaging';
        return axios.get(url, param);
    }

    static uploadSimpleXlsImportfile(param) {
        const url = process.env.VUE_APP_BACKEND_URL + '/simpleXlsLoader';
        return axios.post(
            url,
            param,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    }

    static getSimpleXslLoaderStatus(progressId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/simpleXlsLoader/getXslLoaderStatus';
        return axios.get(url, {
            params: {
                progressId: progressId
            }
        });

    }

    static deleteSimpleImportedPatients(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/simpleXlsLoader?id=' + id;
        return axios.delete(url);
    }

    ////////////////////

    // Utility XLS loader

    static getAllUtilityXlsFiles(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/utilityXlsLoader/listByPaging';
        return axios.get(url, params);
    }

    static uploadUtilityXlsImportfile(param) {
        const url = process.env.VUE_APP_BACKEND_URL + '/utilityXlsLoader';
        return axios.post(
            url,
            param,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    }

    static getUtilityXlsLog(param) {
        const url = process.env.VUE_APP_BACKEND_URL + '/utilityXlsLoader/log/listByPaging';
        return axios.get(url, param);
    }

    static loadUtilityXlsToDatabase(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/utilityXlsLoader/loadXls?id=' + id;
        return axios.post(url);
    }

    static getUtilityXslLoaderStatus(progressId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/utilityXlsLoader/getXslLoaderStatus';
        return axios.get(url, {
            params: {
                progressId: progressId
            }
        });

    }

    static deleteImportedUtility(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/utilityXlsLoader?id=' + id;
        return axios.delete(url);
    }

    ////////////////////

    // Patient waiting
    static getAllPatientWaitingAppointment() {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientSearch/waiting';
        return axios.get(url)
    }
    static setStatusNowDoctor(patientSearchId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientSearch/setStatus?id=' + patientSearchId + '&status=5';
        return axios.put(url);
    }
    ////////////////////

    // My reservations
    static getMyReservationsByParams(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientSearch/myReservations';
        return axios.get(url, params);
    }
    ////////////////////

    // Doctor consult config
    static getAllDoctorConsultConfig(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorCondultConfig/listByPaging';
        return axios.get(url, params);
    }
    static reserveConsultingHour(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorCondultConfig/reserveConsultingHour';
        return axios.post(url, params);
    }
    static modifyConsultingHour(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorCondultConfig/modifyConsultingHourReservation';
        return axios.put(url, params);
    }
    static restoreConsultingHour(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorCondultConfig/restoreReservedConsultingHour?id=' + id;
        return axios.post(url);
    }
    static deleteConsultingHour(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorCondultConfig?id=' + id;
        return axios.delete(url);
    }
    static saveDoctorConsultConfig(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorCondultConfig';
        return axios.post(url, params);
    }
    static deleteDoctorConsultConfig(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorCondultConfig?id=' + id;
        return axios.delete(url);
    }

    static getAllDoctor() {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctor/doctor?onlyActive=true';
        return axios.get(url);
    }
    static getAllOccupationHealthDoctor() {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctor/occupationHealthDoctor';
        return axios.get(url);
    }

    static getDaysOfWeek() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=145';
        return axios.get(url);
    }

    static getAllRoomByType1182(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/room/clear';
        return axios.get(url, params);
    }

    static checkConsultingHour(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorCondultConfig/getConsultingDates';
        return axios.post(url, params)
    }

    static getDoctorHolidayByDoctorId(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorCondultConfigHoliday/findByDoctorId?doctorId=' + id;
        return axios.get(url);
    }

    static getDoctorHolidayById(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorCondultConfigHoliday/findById/' + id
        return axios.get(url);
    }

    static saveDoctorHoliday(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorCondultConfigHoliday';
        return axios.put(url, params)
    }

    static modifyDoctorHoliday(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorCondultConfigHoliday';
        return axios.post(url, params)
    }

    static deleteDoctorHoliday(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorCondultConfigHoliday?id=' + id;
        return axios.delete(url);
    }

    static getCompanySitesByCompanyId() {
        const url = process.env.VUE_APP_BACKEND_URL + '/companySite/selectdata';
        return axios.get(url);
    }

    static getAllCompany() {
        const url = process.env.VUE_APP_BACKEND_URL + '/company/selectdata';
        return axios.get(url);
    }
    ////////////////////

    // EESZT
    static needEESZTLogin() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-sts/needEESZTLogin';
        return axios.get(url);
    }

    static logoutEESZT() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-sts/logout';
        return axios.post(url);
    }

    static loginEESZTStsUsername(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-sts/login-stsusername';
        return axios.post(url, params);
    }

    static loginEESZTStsOTP(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-sts/login-stsotp';
        return axios.post(url, params);
    }

    static loginEESZTStsMOTP(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-sts/login-stsmotp';
        return axios.post(url, params);
    }

    static getRSS() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-rss/get-feed';
        return axios.get(url);
    }

    static getSumEProfile(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/search-adat-sum';
        return axios.post(url, params);
    }

    static getEprofileByDataType(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/search-adat';
        return axios.post(url, params);
    }

    static deleteEprofile(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/delete-adat';
        return axios.post(url, params);
    }

    static saveEprofileAllergia(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/update-adat-figy-allergia';
        return axios.post(url, params);
    }

    static saveEprofileNemAllergia(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/update-adat-figy-egyeb';
        return axios.post(url, params);
    }

    static saveEprofileVedooltas(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/update-adat-kor-vedooltas';
        return axios.post(url, params);
    }

    static saveEprofileKorabbiMutet(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/update-adat-kor-kmutet';
        return axios.post(url, params);
    }

    static saveEprofileAktProblemak(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/update-adat-jel-aktualis';
        return axios.post(url, params);
    }

    static saveEprofileLezartProblemak(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/update-adat-kor-lezart';
        return axios.post(url, params);
    }

    static saveEprofileImplantatum(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/update-adat-jel-implant';
        return axios.post(url, params);
    }

    static saveEprofileTerapia(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/update-adat-jel-terapiak';
        return axios.post(url, params);
    }

    static saveEprofileAutonomia(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/update-adat-jel-autonomia';
        return axios.post(url, params);
    }

    static saveEprofileAktGyogy(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/update-adat-gyogy-akt-gyogy';
        return axios.post(url, params);
    }

    static saveEprofileEletmod(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/update-adat-emod-eletmod';
        return axios.post(url, params);
    }

    static saveEprofileTerhesseg(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/update-adat-ter-terhesseg';
        return axios.post(url, params);
    }

    static saveEprofileVercsoport(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/update-adat-diag-vercsoport';
        return axios.post(url, params);
    }

    static getBizonyossagList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/getBizonyossagList';
        return axios.get(url, params);
    }

    static getOnrendelkezesList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/getOnrendelkezesList';
        return axios.get(url, params);
    }

    static getLeirasKodList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/getLeirasKodList';
        return axios.get(url, params);
    }

    static getOltasKodList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/getOltasKodList';
        return axios.get(url, params);
    }

    static getLezartProblemaKodList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/getLezartProblemaKodList';
        return axios.get(url, params);
    }

    static getBeavatkozasKodList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/getBeavatkozasKodList';
        return axios.get(url, params);
    }

    static getImplantatumKodList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/getImplantatumKodList';
        return axios.get(url, params);
    }

    static getImplantatumNevList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/getImplantatumNevList';
        return axios.get(url, params);
    }

    static getTerapiaTipusList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/getTerapiaTipusList';
        return axios.get(url, params);
    }

    static getAutonomiaKodList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/getAutonomiaKodList';
        return axios.get(url, params);
    }

    static getHatoanyagKodList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/getHatoanyagKodList';
        return axios.get(url, params);
    }

    static getGyogyszereszetiDozisformaKodList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/getGyogyszereszetiDozisformaKodList';
        return axios.get(url, params);
    }

    static getEletmodList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/getEletmodList';
        return axios.get(url, params);
    }

    static getTerhessegKimenetKodList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/getTerhessegKimenetKodList';
        return axios.get(url, params);
    }

    static getVercsoportList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/getVercsoportList';
        return axios.get(url, params);
    }

    static getKivaltoTenyezoTipusList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/getKivaltoTenyezoTipusList';
        return axios.get(url, params);
    }

    static getAgensTipusList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/getAgensTipusList';
        return axios.get(url, params);
    }

    static getReakcioKodList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/getReakcioKodList';
        return axios.get(url, params);
    }

    static getAgensElelmiszerList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/getAgensElelmiszerList';
        return axios.get(url, params);
    }

    static getAgensKornyezetiTenyezoList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-eprofil/getAgensKornyezetiTenyezoList';
        return axios.get(url, params);
    }

    static getFelirtReceptek(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-erecept/search-prescription-by-patient';
        return axios.post(url, params);
    }

    static getKiadottReceptek(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-erecept/search-prescription-by-patient';
        return axios.post(url, params);
    }

    static deleteFelirtRecept(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-erecept/delete-prescription';
        return axios.post(url, params);
    }

    static printPrescriptionCertificate(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-erecept/print-prescription-certificate';
        return axios.post(url, params);
    }

    static printPrescription(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-erecept/print-prescription';
        return axios.post(url, params);
    }

    static getIdTypeList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-erecept/getIdTypeList';
        return axios.get(url, params);
    }

    static getBnoKodList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-erecept/getBnoKodList';
        return axios.get(url, params);
    }

    static getPatientSexList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-erecept/getPatientSexList';
        return axios.get(url, params);
    }

    static getVenyirasiKategoriaList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-erecept/getVenyirasiKategoriaList';
        return axios.get(url, params);
    }

    static getJogcimList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-erecept/getJogcimList';
        return axios.get(url, params);
    }
    static getJogcimListByTtt(ttt) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-erecept/getJogcimListByTtt';
        return axios.get(url, {
            params: {
                id: ttt
            }
        });
    }
    static getAggregatedEUPontokByTtt(ttt) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-erecept/getAggregatedEUPontokByTtt';
        return axios.get(url, {
            params: {
                idTermek: ttt
            }
        });
    }

    static getVenyTipusaList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-erecept/getVenyTipusaList';
        return axios.get(url, params);
    }

    static getTermekTipusList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-erecept/getTermekTipusList';
        return axios.get(url, params);
    }

    static getDrugByFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/drugs/drugFilter';
        return axios.get(url, params);
    }

    static getNicheByFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/drugs/nicheFilter';
        return axios.get(url, params);
    }

    /*static getGyseProductByFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/drugs/gyseFilter';
        return axios.get(url, params);
    }*/

    static getGyseProductByFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-egyse/gyseFilter';
        return axios.get(url, params);
    }

    static getGyse19IsoList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/drugs/getGyse19IsoList';
        return axios.get(url, params);
    }

    static getKolcsonozhetoGYSE(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eesztPuphaX/getKolcsonozhetoGYSE';
        return axios.get(url, params);
    }

    static getMagisProductByFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/drugs/magisFilter';
        return axios.get(url, params);
    }

    static getAdagolasTipusaList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-erecept/getAdagolasTipusaList';
        return axios.get(url, params);
    }

    static getAdagolasTipusaGyseList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-erecept/getAdagolasTipusaGyseList';
        return axios.get(url, params);
    }

    static getFelirasMennyisegiEgysegeList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-erecept/getFelirasMennyisegiEgysegeList';
        return axios.get(url, params);
    }

    static getReceptFelirasMennyisegiEgysegeList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-erecept/getReceptFelirasMennyisegiEgysegeList';
        return axios.get(url, params);
    }

    static getDrugByTTT(tttId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/drugs/getDrugByTtt/' + tttId;
        return axios.get(url);
    }

    static sendPrescription(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-erecept/send-prescription';
        return axios.post(url, params);
    }

    static sendAndPrintPrescription(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-erecept/sendAndPrintPrescription';
        return axios.post(url, params);
    }
    static printPrescriptionHard(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-erecept/printPrescriptionHard';
        return axios.post(url, params);
    }

    static getEreceptErrorMessage() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-erecept/getEreceptErrorMessage';
        return axios.get(url);
    }

    static checkPrescriptionRestriction(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-erecept/checkPrescriptionRestriction';
        return axios.get(url, params);
    }

    // EESZT eGYSE
    static getGyseReceptek(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-egyse/search-egyse-prescription-by-patient';
        return axios.post(url, params);
    }

    static sendAndPrintEGYSE(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-egyse/sendAndPrintPrescription';
        return axios.post(url, params);
    }

    static getEGYSEFelirasMennyisegiEgysegeList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-egyse/getFelirasMennyisegiEgysegeList';
        return axios.get(url, params);
    }

    static deleteGyseRecept(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-egyse/delete-egyse-prescription';
        return axios.post(url, params);
    }

    static printGysePrescriptionCertificate(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-egyse/print-egyse-prescription-certificate';
        return axios.post(url, params);
    }

    static getSpecRecoWarningMessage(oepTtt) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-egyse/getSpecRecoWarningMessage';
        return axios.get(url, {
            params: {
                oepTtt: oepTtt
            }
        });
    }

    static checkKihordasiIdonBeluliFeliras(patientId, termekTtt) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-egyse/checkKihordasiIdonBeluliFeliras';
        return axios.get(url, {
            params: {
                patientId: patientId,
                termekTtt: termekTtt
            }
        });
    }

    static checkEgyseSpecReco(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-egyse/checkEgyseSpecReco';
        return axios.get(url, params);
    }
    //////////////////////////

    // EESZT logins
    static getAllEESZTLogins(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-logins/listByPaging';
        return axios.get(url, params)
    }

    // EESZT log
    static getAllEESZTLog(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-log/listByPaging';
        return axios.get(url, params)
    }
    static getEesztFunctionTypes(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=22000';
        return axios.get(url, params);
    }
    static getUserWithEesztUser(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-log/getUserWithEesztUser';
        return axios.get(url, params)
    }
    static getCompaniesWithEesztData(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-log/getCompaniesWithEesztData';
        return axios.get(url, params)
    }
    static getAllEESZTCertifications() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-log/listEesztCertifications';
        return axios.get(url)
    }
    ////////////////////

    // EESZT resend
    static getMyEesztResend(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-timeout-request/listByPaging';
        return axios.get(url, params)
    }
    static getCountEesztResendRequests(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-timeout-request/getCount';
        return axios.get(url, params)
    }
    static resendEesztRequest(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-timeout-request/resend/' + id;
        return axios.get(url)
    }
    ////////////////////

    // Lab handle
    static getAllLabHandle(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/listByPaging';
        return axios.get(url, params)
    }

    static getAllLabHandleStatus(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/status';
        return axios.get(url, params);
    }
    static getCreatininValues(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=160100';
        return axios.get(url, params);
    }

    static getAllLabHandleType() {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/labType';
        return axios.get(url);
    }

    static saveLabHandle(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/save';
        return axios.post(url, params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    }
    static updateLabHandle(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle';
        return axios.post(url, params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    }

    static savePatientLabHandle(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle';
        return axios.post(url, params);
    }

    static deleteLabHandle(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle';
        return axios.delete(url, params);
    }

    static getPatientLabByPatientId(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/patientLabs';
        return axios.get(url, params);
    }
    static getLabDocument(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/userPatientLabs/downloadLab/' + id;
        return axios.get(url);
    }
    static printLabBid(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/printLabBid/' + id;
        return axios.get(url);
    }
    static printLabEtikettSticker(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/printLabEtikettSticker/' + id;
        return axios.get(url);
    }
    ////////////////////

    // Log
    static logDetail(detail) {
        const headers = {
            'Content-Type': 'text/plain'
        };
        const url = process.env.VUE_APP_BACKEND_URL + '/log';
        return axios.post(url, detail, { headers: headers });
    }
    ////////////////////

    // Appointments
    static saveAppointment(data, params) {
        let url
        if (params.id) {
            url = process.env.VUE_APP_BACKEND_URL + '/appointments?irId=' + params.id;
        } else {
            url = process.env.VUE_APP_BACKEND_URL + '/appointments';
        }
        return axios.post(url, data)
    }
    static updateAppointment(data) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments';
        return axios.put(url, data)
    }
    static getAppointmentsByInterval(date) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/byInterval';
        return axios.post(url, { view: "agendaDay", date: date })
    }
    static getOccupationHealthAppointmentsByInterval(date) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/occupationHealthAppointmentByInterval';
        return axios.post(url, { view: "agendaDay", date: date })
    }
    static getOccupationHealthDoctorAppointmentsByInterval(date) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/occupationHealthDoctorAppointmentByInterval';
        return axios.post(url, { view: "agendaDay", date: date })
    }
    //lekérdezés az összes foglalkozás egészségügyi kezelelés ID-jához (listában tárolva)
    static getOccupationHealthIdsForAppointment() {
        const url = process.env.VUE_APP_BACKEND_URL + '/treatmentType/getAllOccupationHealthTreatmentTypeIds';
        return axios.get(url);
    }
    static getAppointmentStatusById(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/status-by-id';
        return axios.get(url, {
            params: {
                id: id
            }
        });
    }
    static getConsultingByInterval(date) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctor/consultingByInterval';
        return axios.post(url, {
            view: "agendaDay",
            date: date
        })
    }

    static saveCommentToCalendar(params) {
        const url =
            process.env.VUE_APP_BACKEND_URL +
            "/doctorCondultConfig/saveReceptionComment";
        return axios.post(url, params);
    }

    static getOccupationHealthConsultingByInterval(date) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctor/occupationHealthConsultingByInterval';
        return axios.post(url, {
            view: "agendaDay",
            date: date
        })
    }
    static getOccupationHealthDoctorConsultingByInterval(date) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctor/occupationHealthDoctorConsultingByInterval';
        return axios.post(url, {
            view: "agendaDay",
            date: date
        })
    }
    static getCompanySiteRooms() {
        const url = process.env.VUE_APP_BACKEND_URL + '/room/appointmentRooms';
        return axios.get(url);
    }
    static getAppointmentStatus() {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/status';
        return axios.get(url);
    }
    static deleteAppointment(patientSearchFormAppointmentId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/' + patientSearchFormAppointmentId;
        return axios.delete(url);
    }
    static getAppointment(appointmentId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/' + appointmentId;
        return axios.get(url);
    }
    static getTreatmentTypeById(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/treatmentType/findById';
        return axios.get(url, params);
    }
    static modifyAppointmentByDrop(appointmentId, minuteDelta) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/modifybydrop/' + appointmentId + '?minuteDelta=' + minuteDelta;
        return axios.put(url)
    }
    static getAllWaitingPatientFrom(from) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientSearch/waiting-patients-from';
        return axios.get(url, {
            params: {
                from: from
            }
        });
    }
    static setPatientWaitingStatus(id, status) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientSearch/setStatus?id=' + id + "&status=" + status;
        return axios.put(url);
    }
    static setAppointmentStatusFromArrivedToNowDoctor(appointmentId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/setAppointmentStatusFromArrivedToNowDoctor?id=' + appointmentId;
        return axios.put(url);
    }
    static getPatientsByOccupationHealthGroup(params, siteGroupId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroup/getPatientsBySiteGroup?siteGroupId=' + siteGroupId;
        return axios.get(url, params);
    }
    static getPatientsByOccupationHealth(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroupPatient/listByPaging'
        return axios.get(url, params);
    }
    static editEmploymentRelationship(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroupPatient/modifyEmploymentRelationship';
        return axios.put(url, params);
    }
    static getPatientsOccupationHealthById(patientId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroupPatient/findByPatientId/' + patientId;
        return axios.get(url);
    }
    static getPatientsByOccupationHealthPartner(partnerId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroup/getPatientsByOccupationHealthPartner?partnerId=' + partnerId;
        return axios.get(url);
    }
    static getOccupationHealthEmployeeInfo(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroupPatient/findVSiteGroupPatient?id=' + params.id + "&partnerId=" + params.partnerId + "&partnerSiteId=" + params.partnerSiteId
        return axios.get(url);
    }

    // Inpatient appointments
    static getInpatientAppointmentsByInterval(date) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/byIntervalInpatient';
        return axios.post(url, { view: "agendaDay", date: date })
    }
    static getCompanySiteRoomsInpatient() {
        const url = process.env.VUE_APP_BACKEND_URL + '/room/inPatientAppointmentRooms';
        return axios.get(url);
    }
    static getInpatientAppointment(appointmentId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/findOperationById/' + appointmentId;
        return axios.get(url);
    }
    static getAllOperationType(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/operation/whoCodes';
        return axios.get(url, params);
    }
    static getAllAnesthesiaType() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=152';
        return axios.get(url);
    }
    static getAllFamilyToFId() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=10';
        return axios.get(url);
    }
    static getAllOperationRoom() {
        const url = process.env.VUE_APP_BACKEND_URL + '/room/clear';
        return axios.get(url);
    }
    static getAllBedsForOperation() {
        const url = process.env.VUE_APP_BACKEND_URL + '/room/bedsForSelect';
        return axios.get(url);
    }
    static getAllOperationScrubs() {
        const url = process.env.VUE_APP_BACKEND_URL + '/operation/operatingDresser';
        return axios.get(url);
    }
    static getAllAnesthesist() {
        const url = process.env.VUE_APP_BACKEND_URL + '/operation/anesthesist';
        return axios.get(url);
    }
    static getDoctorParticipantTypeId() {
        const url = process.env.VUE_APP_BACKEND_URL + '/operation/getParticipantType';
        return axios.get(url);
    }
    static createOperation(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/operation';
        return axios.post(url, params);
    }
    static modifyOperation(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/operation';
        return axios.put(url, params);
    }
    static deleteOperation(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/operation/' + id;
        return axios.delete(url);
    }
    static createOperationAttendance(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/attendance';
        return axios.post(url, params);
    }
    static modifyInpatientAppointmentByDrop(appointmentId, minuteDelta) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/modifybydropInpatient/' + appointmentId + '?minuteDelta=' + minuteDelta;
        return axios.put(url)
    }
    ///////////////////

    // Patient history
    static getAllPatientHistory(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientHistory/listByPaging';
        return axios.get(url, params);
    }
    ///////////////////

    // Occupation health notification error log
    static getOccupationHealthNotificationErrorLog(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthNotificationErrorLog/listByPaging';
        return axios.get(url, params);
    }

    static resendSingleNotification(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthNotificationErrorLog/resendSingle';
        return axios.post(url, null, { params: { id } });
    }

    static resendNotificationsByDate(date) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthNotificationErrorLog/resendByDate';
        return axios.post(url, null, { params: { date } });
    }
    ///////////////////

    // Lab handle history
    static getAllLabHandleHistory(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandleHistory/listByPaging';
        return axios.get(url, params);
    }

    static getLabDocumentsHistory(labId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandleHistory/getLabDocumentsHistory/' + labId;
        return axios.get(url)
    }
    ///////////////////

    // Patient evidence history
    static getPatientEvidenceHistory(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientEvidenceHistory/listByPaging';
        return axios.get(url, params);
    }

    ///////////////////

    // Staff
    static getAllStaff(withDeleted) {
        if (withDeleted) {
            const url = process.env.VUE_APP_BACKEND_URL + '/staff?withDeleted=true';
            return axios.get(url);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/staff';
            return axios.get(url);
        }
    }
    static getStaffEmployeeStates() {
        const url = process.env.VUE_APP_BACKEND_URL + '/staff/employeeState';
        return axios.get(url);
    }
    static saveStaff(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/staff';
        if (params.id) {
            return axios.post(url, params);
        } else {
            return axios.put(url, params);
        }
    }
    static deleteStaff(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/staff?id=' + id;
        return axios.delete(url);
    }
    static unDeleteStaff(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/staff/setUnDelete?id=' + id;
        return axios.post(url);
    }

    static getHumanResourceEducations(withDeleted, employeeId, employeeTypeId) {
        if (withDeleted) {
            const url = process.env.VUE_APP_BACKEND_URL + '/hrEducation?withDeleted=true&id=' + employeeId + '&employeeType=' + employeeTypeId;
            return axios.get(url);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/hrEducation?id=' + employeeId + '&employeeType=' + employeeTypeId;
            return axios.get(url);
        }
    }
    static saveHumanResourceEducation(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/hrEducation';
        if (params.id) {
            return axios.post(url, params);
        } else {
            return axios.put(url, params);
        }
    }
    static deleteHumanResourceEducation(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/hrEducation?id=' + id;
        return axios.delete(url);
    }
    static unDeleteHumanResourceEducation(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/hrEducation/setUnDelete?id=' + id;
        return axios.post(url);
    }

    static getHumanResourceCompany(employeeId, employeeTypeId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/hrCompany?id=' + employeeId + '&employeeType=' + employeeTypeId;
        return axios.get(url);
    }
    static saveHumanResourceCompany(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/hrCompany';
        if (params.id) {
            return axios.post(url, params);
        } else {
            return axios.put(url, params);
        }
    }

    static getHumanResourceFees(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/hrFee';
        return axios.get(url, params);
    }
    static saveHumanResourceFee(params) {
        if (params.humanResourceFee.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/hrFee/updateGroup';
            return axios.post(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/hrFee/save';
            return axios.put(url, params);

        }
    }
    static deleteHumanResourceFee(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/hrFee/deleteGroup?id=' + id;
        return axios.delete(url);
    }
    static unDeleteHumanResourceFee(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/hrFee/undeleteGroup?id=' + id;
        return axios.delete(url);
    }
    ///////////////////

    // Human resource
    static getAllHumanResource(withDeleted) {
        if (withDeleted) {
            const url = process.env.VUE_APP_BACKEND_URL + '/humanResource?withDeleted=true';
            return axios.get(url);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/humanResource';
            return axios.get(url);
        }
    }
    static saveHumanResource(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/humanResource';
        if (params.id) {
            return axios.post(url, params);
        } else {
            return axios.put(url, params);
        }
    }
    static deleteHumanResource(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/humanResource?id=' + id;
        return axios.delete(url);
    }
    static unDeleteHumanResource(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/humanResource/setUnDelete?id=' + id;
        return axios.post(url);
    }

    static getHumanResourceQualification(withDeleted, employeeId) {
        if (withDeleted) {
            const url = process.env.VUE_APP_BACKEND_URL + '/qualification?withDeleted=true&humanResourceId=' + employeeId;
            return axios.get(url);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/qualification?humanResourceId=' + employeeId;
            return axios.get(url);
        }
    }
    static getOccupationalGroup() {
        const url = process.env.VUE_APP_BACKEND_URL + '/qualification/occupationalGroups';
        return axios.get(url);
    }
    static getQualificationNames() {
        const url = process.env.VUE_APP_BACKEND_URL + '/qualification/qualification';
        return axios.get(url);
    }
    static saveQualification(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/qualification';
        if (params.id) {
            return axios.post(url, params);
        } else {
            return axios.put(url, params);
        }
    }
    static deleteHumanResourceQualification(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/qualification?id=' + id;
        return axios.delete(url);
    }
    static unDeleteHumanResourceQualification(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/qualification/setUnDelete?id=' + id;
        return axios.post(url);
    }

    static getHRLanguages(withDeleted, employeeId) {
        if (withDeleted) {
            const url = process.env.VUE_APP_BACKEND_URL + '/language?withDeleted=true&id=' + employeeId + '&employeeType=2';
            return axios.get(url);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/language?id=' + employeeId + '&employeeType=2';
            return axios.get(url);
        }
    }
    static saveHRLanguage(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/language';
        if (params.id) {
            return axios.post(url, params);
        } else {
            return axios.put(url, params);
        }
    }
    static deleteHRLanguage(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/language?id=' + id;
        return axios.delete(url);
    }
    static unDeleteHRLanguage(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/language/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static getLanguageMark() {
        const url = process.env.VUE_APP_BACKEND_URL + '/language/mark';
        return axios.get(url);
    }

    static getHRTreatment() {
        const url = process.env.VUE_APP_BACKEND_URL + '/treatmentType';
        return axios.get(url);
    }
    ///////////////////

    // Treatment type
    static getAllTreatmentType(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/treatmentType';
        return axios.get(url, params);
    }
    static getAllTreatmentTypesExtended(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/internalReferral/allTreatmentTypes';
        return axios.get(url, params);
    }
    static getAllTreatmentForDoctor(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/treatmentType/treatmentForDoctor';
        return axios.get(url, params);
    }
    static getAllTreatmentForDoctorByConsultConfigId(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/treatmentType/treatmentByConsultConfigAndDoctorId';
        return axios.get(url, params);
    }
    static getAllTreatmentTypeByPatient(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/treatmentType/listByPaging';
        return axios.get(url, params);
    }
    static getOccupationHealthTreatmentType(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/treatmentType/occupationHealthTreatmentTypes';
        return axios.get(url, params);
    }
    static getOccupationHealthTreatmentTypeSelect(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/treatmentType/occupationHealthTreatmentTypesSelect';
        return axios.get(url, params);
    }
    static getAllInstrumentToTreatmentType() {
        const url = process.env.VUE_APP_BACKEND_URL + '/instrument?withDeleted=false';
        return axios.get(url);
    }
    static getAllStockToTreatmentType() {
        const url = process.env.VUE_APP_BACKEND_URL + '/stock?withDeleted=false';
        return axios.get(url);
    }
    static saveTreatmentType(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/treatmentType';
            return axios.post(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/treatmentType';
            return axios.put(url, params);
        }
    }
    static deleteTreatmentType(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/treatmentType?id=' + id;
        return axios.delete(url);
    }
    static undeleteTreatmentType(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/treatmentType/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static getTreatmentCategories() {
        const url = process.env.VUE_APP_BACKEND_URL + '/treatmentType/getTreatmentCategories';
        return axios.get(url);
    }
    // Unique treatment duration
    static getAllUniqueTreatmentDuration(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/uniqueTreatmentDuration/listByPaging';
        return axios.get(url, params);
    }
    static saveUniqueTreatmentDuration(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/uniqueTreatmentDuration';
            return axios.post(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/uniqueTreatmentDuration';
            return axios.put(url, params);
        }
    }
    static deleteUniqueTreatmentDuration(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/uniqueTreatmentDuration?id=' + id;
        return axios.delete(url);
    }
    static unDeleteUniqueDurationRow(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/uniqueTreatmentDuration/undelete?id=' + id;
        return axios.delete(url);
    }
    static getUniqueTreatmentDurationByDoctorId(doctorId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/uniqueTreatmentDuration/findByDoctorId?doctorId=' + doctorId;
        return axios.get(url);
    }

    ///////////////////

    // Room
    static getAllRoom(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/room';
        return axios.get(url, params);
    }
    static deleteRoom(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/room?id=' + id;
        return axios.delete(url);
    }
    static getRoomTypes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientSearch/room';
        return axios.get(url);
    }
    static saveRoom(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/room';
            return axios.post(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/room';
            return axios.put(url, params);
        }
    }
    static unDeleteRoom(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/room/setUnDelete?id=' + id;
        return axios.post(url);
    }

    static getAllBedByRoomId(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/bed';
        return axios.get(url, params);
    }
    static saveBed(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/bed';
            return axios.post(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/bed';
            return axios.put(url, params);
        }
    }
    static deleteBed(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/bed?id=' + id;
        return axios.delete(url);
    }
    static unDeleteBed(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/bed/setUnDelete?id=' + id;
        return axios.post(url);
    }
    // healthInsurancePartner - beküldő partnerek
    static getHealthInsurancePartner(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/healthInsurancePartner/listByPaging';
        return axios.get(url, params);
    }
    static saveHealthInsurancePartner(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/healthInsurancePartner/update';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/healthInsurancePartner/insert';
            return axios.post(url, params);
        }
    }
    static deleteHealthInsurancePartner(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/healthInsurancePartner/delete?id=' + id;
        return axios.delete(url);
    }
    static unDeleteHealthInsurancePartner(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/healthInsurancePartner/restore?id=' + id;
        return axios.put(url);
    }
    ///////////////////
    //OtherExaminationDocumentTypes
    static getAllOtherExaminationDocumentTypes(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/otherExaminationDocumentTypes/listByPaging';
        return axios.get(url, params);
    }
    static saveOtherExaminationDocumentTypes(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/otherExaminationDocumentTypes/update?id=' + params.id;
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/otherExaminationDocumentTypes/insert';
            return axios.post(url, params);
        }
    }
    static deleteOtherExaminationDocumentTypes(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/otherExaminationDocumentTypes/delete?id=' + id;
        return axios.delete(url);
    }
    static unDeleteOtherExaminationDocumentTypes(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/otherExaminationDocumentTypes/restore?id=' + id;
        return axios.delete(url);
    }
    static findByIdOtherExaminationDocumentTypes(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/otherExaminationDocumentTypes/findById?id=' + id;
        return axios.get(url);
    }
    static findAllActiveExaminationDocumentTypes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/otherExaminationDocumentTypes/getAllActive';
        return axios.get(url);
    }
    static findAllRichterActiveExaminationDocumentTypes(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/otherExaminationDocumentTypes/getAllActiveRichter?patientId=' + params.params.patientId;
        return axios.get(url);
    }
    static findAllActivePulmonary() {
        const url = process.env.VUE_APP_BACKEND_URL + '/otherExaminationDocumentTypes/getAllPulmonary';
        return axios.get(url);
    }
    static getRichterReferralByPatient(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/otherExaminationDocumentTypes/getRichterReferralByPatient?patientId=' + params.params.patientId;
        return axios.get(url);
    }
    static getOtherExaminationByReferral(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/otherExaminationDocumentTypes/getOtherExaminationByReferral?referralId=' + params.params.referralId + '&patientId=' + params.params.patientId;
        return axios.get(url);
    }
    static getOtherExaminationByReferralForUpdate(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/otherExaminationDocumentTypes/getOtherExaminationByReferralForUpdate?referralId=' + params.params.referralId + '&labId=' + params.params.labId + '&patientId=' + params.params.patientId;
        return axios.get(url);
    }
    static findExaminationByIdForUpdate(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/labHandle/findById?id=' + id;
        return axios.get(url);
    }
    // Instrument
    static getInstrumentTypes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/instrument/instrumentTypes';
        return axios.get(url);
    }
    static getAllInstrument(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/instrument';
        return axios.get(url, params);
    }
    static saveInstrument(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/instrument';
        return axios.post(url, params);
    }
    static deleteInstrument(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/instrument?id=' + id;
        return axios.delete(url);
    }
    static unDeleteInstrument(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/instrument/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static uploadInstrumentDocument(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/instrumentDocument';
        return axios.post(
            url,
            params,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    }
    static loadInstrumentDocumentById(instrumentId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/instrumentDocument/get-document/' + instrumentId;
        return axios.get(url);
    }
    ///////////////////

    // Doctor

    static getAllDoctorPaging(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctor/listByPaging';
        return axios.get(url, params);
    }
    static getAllDoctorWithoutBEPaging(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctor/getAllDoctors';
        return axios.get(url, params);
    }
    static getLoggedInDoctorInfo(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctor/getLoggedInDoctorInfo';
        return axios.get(url, params);
    }
    static saveDoctor(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/doctor';
            return axios.post(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/doctor';
            return axios.put(url, params);
        }
    }
    static getDoctorUsers() {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctor/withRole?role=ROLE_DOCTOR';
        return axios.get(url);
    }
    static getFreeDoctorUsers() {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctor/freeDoctorUsers';
        return axios.get(url);
    }
    static deleteDoctor(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctor?id=' + id;
        return axios.delete(url);
    }
    static getDoctorById(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctor/' + id;
        return axios.get(url);
    }
    static unDeleteDoctor(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctor/setUnDelete?id=' + id;
        return axios.post(url);
    }

    static getAllTreatmentTypeForTreatments(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/treatmentType?withDeleted=false';
        return axios.get(url, params);
    }

    static getAllPrescRestrTypes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/drugs/getAllPrescRestrTypes';
        return axios.get(url);
    }

    static getDoctorExams(withDeleted, doctorId) {
        if (withDeleted) {
            const url = process.env.VUE_APP_BACKEND_URL + '/exam?withDeleted=true&id=' + doctorId + '&employeeType=1';
            return axios.get(url);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/exam?id=' + doctorId + '&employeeType=1';
            return axios.get(url);
        }
    }
    static deleteExam(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/exam?id=' + id;
        return axios.delete(url);
    }
    static unDeleteExam(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/exam/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static saveExam(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/exam';
            return axios.post(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/exam';
            return axios.post(url, params);
        }
    }
    static getExamSzakvkod() {
        const url = process.env.VUE_APP_BACKEND_URL + '/exam/getSzakvkod';
        return axios.get(url);
    }

    static uploadDoctorExamDocument(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorExamDocument';
        return axios.post(
            url,
            params,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    }
    static getDoctorExamDocument(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorExamDocument/getDocument/' + id;
        return axios.get(url);
    }

    static getDoctorLanguages(withDeleted, employeeId) {
        if (withDeleted) {
            const url = process.env.VUE_APP_BACKEND_URL + '/language?withDeleted=true&id=' + employeeId + '&employeeType=1';
            return axios.get(url);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/language?id=' + employeeId + '&employeeType=1';
            return axios.get(url);
        }
    }

    ///////////////////

    // Role management
    static getAllRole() {
        const url = process.env.VUE_APP_BACKEND_URL + '/permission/roles';
        return axios.get(url);
    }

    static deleteRole(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/permission/deleteRole?id=' + id;
        return axios.delete(url);
    }

    static saveRole(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/permission/updateRole';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/permission/newRole';
            return axios.put(url, params);
        }
    }

    static getAllPermission() {
        const url = process.env.VUE_APP_BACKEND_URL + '/permission';
        return axios.get(url);
    }

    static deletePermission(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/permission/deletePermission?id=' + id;
        return axios.delete(url);
    }

    static savePermission(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/permission/updatePermission';
            return axios.post(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/permission';
            return axios.post(url, params);
        }
    }
    ///////////////////

    // Organization unit
    static findAllOrganizationUnit(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/organizationUnit/findAll';
        return axios.get(url, params);
    }
    static findAllOrganizationUnitWithoutDeleted(params) {
            const url = process.env.VUE_APP_BACKEND_URL + '/organizationUnit/findAllWithoutDeleted';
            return axios.get(url, params);
    }
    static getAllOrganizationUnit(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/organizationUnit/listByPaging';
        return axios.get(url, params);
    }
    static saveOrganizationUnit(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/organizationUnit';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/organizationUnit';
            return axios.post(url, params);
        }
    }
    static deleteOrganizationUnit(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/organizationUnit?id=' + id;
        return axios.delete(url);
    }
    static unDeleteOrganizationUnit(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/organizationUnit/undelete?id=' + id;
        return axios.delete(url);
    }
    static getAllOrganizationUnitsForSelect() {
        const url = process.env.VUE_APP_BACKEND_URL + '/organizationUnit/select';
        return axios.get(url);
    }
    static getOrganizationUnitsForSelectMySiteUnits() {
        const url = process.env.VUE_APP_BACKEND_URL + '/organizationUnit/selectMySiteUnits';
        return axios.get(url);
    }
    static getMyEESZTOrganizationUnit() {
        const url = process.env.VUE_APP_BACKEND_URL + '/organizationUnit/getMyEesztOrganizationUnit';
        return axios.get(url);
    }
    static checkTreatmentOrganizationUnit(appointmentId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/organizationUnit/checkTreatmentOrganizationUnit/' + appointmentId;
        return axios.get(url);
    }
    ///////////////////

    // Company
    static getAllCompanies(withDeleted) {
        if (withDeleted) {
            const url = process.env.VUE_APP_BACKEND_URL + '/company?withDeleted=true';
            return axios.get(url);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/company';
            return axios.get(url);
        }

    }
    static saveCompany(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/company';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/company';
            return axios.post(url, params);
        }
    }
    static deleteCompany(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/company?id=' + id;
        return axios.delete(url);
    }
    ///////////////////

    // Document log
    static getAllDocumentLog(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/documentLog/listByPaging';
        return axios.get(url, params);
    }
    static getAllUserForSelect(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/users';
        return axios.get(url, params);
    }
    static getDocumentLogDocumentTypes(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=21000';
        return axios.get(url, params);
    }
    static getDocumentLogDocumentActions(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=21100';
        return axios.get(url, params);
    }
    ////////////////////

    // eSeménykatalógus
    static getEsemenyTipusAllList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-esemenykatalogus/getEsemenyTipusAllList';
        return axios.get(url);
    }
    static getEsemenyTipusJarobetegList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-esemenykatalogus/getEsemenyTipusJarobetegList';
        return axios.get(url);
    }
    static getEsemenyTipusFeuList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-esemenykatalogus/getEsemenyTipusFeuList';
        return axios.get(url);
    }
    static getEsemenyTipusCovidRATList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-esemenykatalogus/getEsemenyTipusCovidRATList';
        return axios.get(url);
    }
    static closeEvent(attendanceId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-esemenykatalogus/closeEvent';
        return axios.get(url, {
            params: {
                attendanceId: attendanceId
            }
        });
    }
    static getSzakmaKodList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-esemenykatalogus/getSzakmaKodList';
        return axios.get(url);
    }
    static getAmbulansEllatasList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-esemenykatalogus/getAmbulansEllatasList';
        return axios.get(url);
    }
    static getPaciensTovabbiSorsaList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-esemenykatalogus/getPaciensTovabbiSorsaList';
        return axios.get(url);
    }
    static getFekvobetegJellegeList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-esemenykatalogus/getFekvobetegJellegeList';
        return axios.get(url);
    }
    static getFekvobetegFelvitelTipusaList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-esemenykatalogus/getFekvobetegFelvitelTipusaList';
        return axios.get(url);
    }
    static getAllDoctorForEeszt() {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctor/doctorListForEeszt?onlyActive=true';
        return axios.get(url);
    }
    static getCompanySitesByCompanyIdToEeszt() {
        const url = process.env.VUE_APP_BACKEND_URL + '/companySite/selectDataToEeszt';
        return axios.get(url);
    }

    static saveEsemenyKatalogus(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-esemenykatalogus/add-event-entry';
        return axios.post(url, params)
    }
    static updateEsemenyKatalogus(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-esemenykatalogus/update-event-entry';
        return axios.post(url, params)
    }
    static saveCovidRapidAntigenTest(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-esemenykatalogus/addCovidRapidAntigetTeszt';
        return axios.post(url, params)
    }
    static deleteEsemenyKatalogus(eesztId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-esemenykatalogus/delete-event-entry?eesztId=' + eesztId;
        return axios.delete(url)
    }
    static getEsemenyKatalogusByEesztId(data) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-esemenykatalogus/get-event-entry';
        return axios.post(url, data)
    }
    static getEsemenyKatalogusListByPatient(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-esemenykatalogus/get-events-by-patient';
        return axios.post(url, params)
    }
    static getCovidPcrResults(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-esemenykatalogus/getCovidPcrResults';
        return axios.post(url, params)
    }
    ////////////////////

    // EHR
    static getDokumentumTipusList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ehr/getDokumentumTipusList';
        return axios.get(url);
    }
    static getEllatasList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ehr/getEllatasList';
        return axios.get(url);
    }
    static getCovidRapidTestList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/covidRAT/getCovidRapidTestList';
        return axios.get(url);
    }
    static getMintavetelTipusList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ehr/getMintavetelTipusList';
        return axios.get(url);
    }
    static getEHRList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ehr/get-document-list';
        return axios.post(url, params);
    }
    static deleteEHR(eesztId, version) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ehr/delete-document?eesztId=' + eesztId + '&version=' + version;
        return axios.delete(url)
    }
    static addLabDocument(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ehr/add-lab-document';
        return axios.post(url, params);
    }
    static addFeuLabDocument(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ehr/add-feu-lab-document';
        return axios.post(url, params);
    }
    static addEvideceDocument(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ehr/add-evidence-document';
        return axios.post(url, params);
    }
    static updateEvienceDocument(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ehr/update-evidence-document';
        return axios.post(url, params);
    }
    static getDocumentByEesztId(eesztId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ehr/get-document/' + eesztId;
        return axios.get(url);
    }
    static downloadEHRDocument(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ehr/get-and-download-document';
        return axios.post(url, params);
    }
    static uploadEHRDocument(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ehr/update-document';
        return axios.post(
            url,
            params,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    }
    static updateCovidRATDocument(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ehr/updateCovidRATDocument';
        return axios.post(url, params);
    }
    static saveEhrSpecAdvDrugFormData(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ehr/add-specialist-advice-drug-document';
        return axios.post(url, params);
    }
    ////////////////////

    // E-beutaló
    static getBeutaloAllapotList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ebeutalo/getBeutaloAllapotList';
        return axios.get(url);
    }
    static getKeresesScenarioList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ebeutalo/getKeresesScenarioList';
        return axios.get(url);
    }
    static getBeutaloIntezmenyTipusList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ebeutalo/getBeutaloIntezmenyTipusList';
        return axios.get(url);
    }
    static getBeutalasOkaList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ebeutalo/getBeutalasOkaList';
        return axios.get(url);
    }
    static getUtazasKoltsegteritesList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ebeutalo/getUtazasKoltsegteritesList';
        return axios.get(url);
    }
    static getBeutaloTipusaList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ebeutalo/getBeutaloTipusaList';
        return axios.get(url);
    }
    static getEBeutaloList(params) {
        if (params) {
            const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ebeutalo/search-ebeutalo';
            return axios.post(url, params);
        }
    }
    static saveEbeutalo(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ebeutalo/update-ebeutalo';
        return axios.post(url, params);
    }
    static deleteEBeutalo(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ebeutalo/delete-ebeutalo';
        return axios.post(url, params);
    }
    static rogzitBeutaloFelhasznalas(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ebeutalo/set-ebeutalo-allapot';
        return axios.post(url, params);
    }
    static getBeutaloByEesztId(eesztId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-ebeutalo/search-ebeutalo-by-eesztId/' + eesztId;
        return axios.get(url);
    }

    static getTeritesiKategoriaList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=27000';
        return axios.get(url);
    }
    static getVizsgalatTipusaList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=27050';
        return axios.get(url);
    }
    static getVizsgalatTipusaAList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=27100';
        return axios.get(url);
    }
    static getVizsgalatTipusaBList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=27150';
        return axios.get(url);
    }
    static getTunetekList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=27200';
        return axios.get(url);
    }
    static getGyorstesztEredmenyList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=27250';
        return axios.get(url);
    }
    static getVizsgalatiAnyagList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=27300';
        return axios.get(url);
    }
    static getElsoIsmeteltVizsgalatList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=27350';
        return axios.get(url);
    }
    static getElozoVizsgalatEredmenyList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=27400';
        return axios.get(url);
    }
    ////////////////////

    // Chat
    static getUsersToChatList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/users/list-to-chat';
        return axios.get(url);
    }

    static getMessageArrayByNames(senderId, recipientId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/messages/' + senderId + '/' + recipientId;
        return axios.get(url);
    }

    static getUnseenMessagesCount() {
        const url = process.env.VUE_APP_BACKEND_URL + '/get-unseen-messages-count';
        return axios.get(url);
    }
    ////////////////////

    // Patient health card
    static getYesNoCodeStore() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=10';
        return axios.get(url);
    }
    static getHealthCardByPatient(patientId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientHealthCard/getHealthCardByPatientId/' + patientId;
        return axios.get(url);
    }
    static saveHealthCard(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/patientHealthCard/update';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/patientHealthCard/save';
            return axios.post(url, params);
        }
    }
    static existsHealthCardTemplate() {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientHealthCard/existsTemplate';
        return axios.get(url);
    }
    static downloadHealthCardTemplate(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientHealthCard/print/' + id;
        return axios.get(url);
    }
    ////////////////////

    // Patient periodic aptitude test
    static getPeriodicAptitudeTests(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientPeriodicAptitudeTest/listByPaging';
        return axios.get(url, params);
    }
    static savePeriodicAptitudeTests(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/patientPeriodicAptitudeTest/update';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/patientPeriodicAptitudeTest/save';
            return axios.post(url, params);
        }
    }
    static existsPeriodicAptitudeTemplate() {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientPeriodicAptitudeTest/existsTemplate';
        return axios.get(url);
    }
    static downloadPeriodicAptitudeTemplate(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientPeriodicAptitudeTest/print/' + id;
        return axios.get(url);
    }
    ////////////////////

    // General document template
    static getGeneralDocumentKeys() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=25700';
        return axios.get(url);
    }
    static getAllGeneralDocumentTemplate(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/generalDocumentTemplate';
        return axios.get(url, params);
    }
    static saveGeneralDocumentTemplate(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/generalDocumentTemplate/upload';
        return axios.post(
            url,
            params,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    }
    ////////////////////

    // Patient operations
    static getAllOperationsByPatientId(patientId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/operation/findOperationsByPatientId/' + patientId;
        return axios.get(url);
    }
    ////////////////////

    // GDPR
    // Plea
    static getAllPlea(params, withDeleted) {
        if (withDeleted) {
            const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/plea/listByPaging?withDeleted=true';
            return axios.get(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/plea/listByPaging?withDeleted=false';
            return axios.get(url, params);
        }
    }
    static savePlea(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/plea';
            return axios.post(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/plea';
            return axios.put(url, params);
        }
    }
    static deletePlea(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/plea/listByPaging' + id;
        return axios.delete(url);
    }
    static unDeletePlea(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/plea/undelete?id=' + id;
        return axios.delete(url);
    }
    static getPleaFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/plea/pleaFilter';
        return axios.get(url, params);
    }
    // GDPR person
    static getAllGdprPerson(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/person/listByPaging';
        return axios.get(url, params);
    }
    static getGdprPersonFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/person/personFilter';
        return axios.get(url, params);
    }
    static getUserPersonType(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=26000';
        return axios.get(url, params);
    }
    static getUserPersonTypeFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=26000';
        return axios.get(url, params);
    }
    // Data Asset Inventory Data Handling
    static getDataAssetInventoryDataManagementPeriod(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=37000';
        return axios.get(url, params);
    }
    static getDataAssetInventoryDataManagementPeriodFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=37000';
        return axios.get(url, params);
    }
    // Data Asset Inventory Data Management Place
    static getAllDataAssetInventoryDataManagementPlace(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=36000';
        return axios.get(url, params);
    }
    static getDataAssetInventoryDataManagementPlaceFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=36000';
        return axios.get(url, params);
    }
    // Data Asset Inventory
    static getAllDataAssetInventory(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/dataAssetInventoryController/listByPaging';
        return axios.get(url, params);
    }
    static getAllDataAssetInventoryExport() {
        return axios({
            url: process.env.VUE_APP_BACKEND_URL + '/gdpr/dataAssetInventoryController/exportData',
            method: 'GET',
            responseType: 'blob', // important
        });

    }
    static saveDataAssetInventory(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/dataAssetInventoryController';
            return axios.post(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/dataAssetInventoryController';
            return axios.put(url, params);
        }
    }
    static deleteDataAssetInventory(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/dataAssetInventoryController?id=' + id;
        return axios.delete(url);
    }
    // Incident registration
    static getAllIncidentRegistration(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/incidentRegistration/listByPaging';
        return axios.get(url, params);
    }
    static saveIncidentRegistration(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/incidentRegistration';
            return axios.post(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/incidentRegistration';
            return axios.put(url, params);
        }
    }
    static deleteIncidentRegistration(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/incidentRegistration?id=' + id;
        return axios.delete(url);
    }
    static undeleteIncidentRegistration(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/incidentRegistration/undelete?id=' + id;
        return axios.delete(url);
    }
    static getAllIncidentRegistrationPersonalData(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=33000';
        return axios.get(url, params);
    }
    static getAllIncidentRegistrationPersonalDataFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=33000';
        return axios.get(url, params);
    }
    // Event Registration Personal Data Category
    static getAllEventRegistrationPersonalDataCategory(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=33000';
        return axios.get(url, params);
    }
    static getAllEventRegistrationPersonalDataCategoryFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=33000';
        return axios.get(url, params);
    }
    // Storage Status
    static getAllStorageStatus(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=35000';
        return axios.get(url, params);
    }
    static getAllStorageStatusFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=35000';
        return axios.get(url, params);
    }
    // Event Registration
    static getAllEventRegistration(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/eventRegistration/listByPaging';
        return axios.get(url, params);
    }
    static saveEventRegistration(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/eventRegistration';
            return axios.post(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/eventRegistration';
            return axios.put(url, params);
        }
    }
    static deleteEventRegistration(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/eventRegistration?id=' + id;
        return axios.delete(url);
    }
    static undeleteEventRegistration(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/eventRegistration/undelete?id=' + id;
        return axios.delete(url);
    }
    // Data Transfer Event
    static getAllDataTransferEvent(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/dataTransferEvent/listByPaging';
        return axios.get(url, params);
    }
    static saveDataTransferEvent(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/dataTransferEvent';
            return axios.post(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/dataTransferEvent';
            return axios.put(url, params);
        }
    }
    static deleteDataTransferEvent(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/dataTransferEvent?id=' + id;
        return axios.delete(url);
    }
    static undeleteDataTransferEvent(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/dataTransferEvent/undelete?id=' + id;
        return axios.delete(url);
    }
    // Data Transfer Event Details
    static getAllDataTransferEventDetail(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/dataTransferEventDetail/listByPaging';
        return axios.get(url, params);
    }
    static saveDataTransferEventDetail(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/dataTransferEventDetail';
            return axios.post(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/dataTransferEventDetail';
            return axios.put(url, params);
        }
    }
    static deleteDataTransferEventDetail(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/dataTransferEventDetail?id=' + id;
        return axios.delete(url);
    }

    // Data Transfer Event Frequency
    static getTransferFreq(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=38000';
        return axios.get(url, params);
    }
    static getTransferFreqFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=38000';
        return axios.get(url, params);
    }
    // Impact Assessment Data Handling
    static getAllImpactAssessmentDataHandling(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/impactAssessmentDataHandling/listByPaging';
        return axios.get(url, params);
    }
    static saveImpactAssessmentDataHandling(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/impactAssessmentDataHandling';
            return axios.post(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/impactAssessmentDataHandling';
            return axios.put(url, params);
        }
    }
    static deleteImpactAssessmentDataHandling(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/impactAssessmentDataHandling?id=' + id;
        return axios.delete(url);
    }
    static getImpactAssessmentDataHandlingFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/impactAssessmentDataHandling/impactAssessmentDataHandlingFilter';
        return axios.get(url, params);
    }
    // Impact Assessment Data Management Tool
    static getAllImpactAssessmentDataManagementTool(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=34000';
        return axios.get(url, params);
    }
    static getImpactAssessmentDataManagementToolFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=34000';
        return axios.get(url, params);
    }
    // Impact Assessment
    static getAllImpactAssessment(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/impactAssessment/listByPaging';
        return axios.get(url, params);
    }
    static saveImpactAssessment(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/impactAssessment';
            return axios.post(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/impactAssessment';
            return axios.put(url, params);
        }
    }
    static deleteImpactAssessment(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/impactAssessment?id=' + id;
        return axios.delete(url);
    }
    static undeleteImpactAssessmentDocument(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/impactAssessment/undelete?id=' + id;
        return axios.delete(url);
    }
    static getImpactAssessmentDocument(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/impactAssessment/document/getDocument/' + id;
        return axios.get(url);
    }
    static uploadImpactAssessmentDocument(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/impactAssessment/document/upload';
        return axios.post(
            url,
            params,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    }
    // Data Management Process Form
    static getAllDataManagementProcessForm(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=30000';
        return axios.get(url, params);
    }
    static getDataManagementProcessFormFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=30000';
        return axios.get(url, params);
    }
    // Data Management Process Personal Data Category
    static getAllPersonalDataCategory(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=33000';
        return axios.get(url, params);
    }
    static getAllPersonalDataCategoryFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=33000';
        return axios.get(url, params);
    }
    // Data Management Process Place
    static getAllDataManagementProcessPlaceFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/dataManagementProcessPlace/listByPaging';
        return axios.get(url, params);
    }
    static getAllDataManagementProcessPlace(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/dataManagementProcessPlace/listAll';
        return axios.get(url, params);
    }
    static saveDataManagementProcessPlace(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/dataManagementProcessPlace';
            return axios.post(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/dataManagementProcessPlace';
            return axios.put(url, params);
        }
    }
    static deleteDataManagementProcessPlace(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/dataManagementProcessPlace?id=' + id;
        return axios.delete(url);
    }
    static getDataManagementProcessPlaceFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/dataManagementProcessPlace/dataManagementProcessPlaceFilter';
        return axios.get(url, params);
    }
    // Data Management Process Recipient Category
    static getAllDataManagementProcessRecipientCategory(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=32000';
        return axios.get(url, params);
    }
    static getDataManagementProcessRecipientCategoryFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=32000';
        return axios.get(url, params);
    }
    // Data Management Process Transmission Guarantee
    static getAllDataManagementProcessTransmissionGuarantee(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=31000';
        return axios.get(url, params);
    }
    static getDataManagementProcessTransmissionGuaranteeFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=31000';
        return axios.get(url, params);
    }
    // Data Management Process
    static getAllDataManagementProcessController(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/dataManagementProcess/listByPaging';
        return axios.get(url, params);
    }
    static saveDataManagementProcessController(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/dataManagementProcess';
            return axios.post(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/dataManagementProcess';
            return axios.put(url, params);
        }
    }
    static deleteDataManagementProcessController(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/gdpr/dataManagementProcess?id=' + id;
        return axios.delete(url);
    }
    // Data Source
    static getAllDataSource(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=39000';
        return axios.get(url, params);
    }
    static getAllDataSourceFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=39000';
        return axios.get(url, params);
    }
    ////////////////////

    // COVID-19
    static addCovidLab(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/covid';
        return axios.put(url, params)
    }
    static getCovidPatient(patientId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient/' + patientId;
        return axios.get(url)
    }
    static getCovidEvidence(attendanceId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/treatment/attendance/' + attendanceId;
        return axios.get(url)
    }
    static getCovidLab(labId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/' + labId;
        return axios.get(url)
    }
    static saveCovidLab(param) {
        const url = process.env.VUE_APP_BACKEND_URL + '/covid/saveLab';
        return axios.post(
            url,
            param,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    }
    static saveCovidEvidence(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/covid/saveEvidence';
        return axios.put(url, params)
    }
    ////////////////////

    // Specialist recommendation
    static getAllSpecialistRecommendation(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/specialist-recommendation';
        return axios.get(url, params);
    }
    static saveSpecialistRecommendation(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/specialist-recommendation';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/specialist-recommendation';
            return axios.post(url, params);
        }
    }
    static saveAndPrintSpecialistRecommendation(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/specialist-recommendation/saveAndPrint';
        return axios.post(url, params);
    }
    static saveSpecialistRecommendationFromForm(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/specialist-recommendation/saveAndPrintFromPrescriptionForm';
        return axios.post(url, params);
    }
    static deleteSpecialistRecommendation(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/specialist-recommendation?id=' + id;
        return axios.delete(url);
    }
    static unDeleteSpecialistRecommendation(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/specialist-recommendation/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static checkRestriction(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/specialist-recommendation/checkRestriction';
        return axios.get(url, params);
    }
    static printSpecialistRecommendationDocument(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/specialist-recommendation/print/' + id;
        return axios.get(url);
    }
    static uploadToEesztSpecialistRecommendation(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/specialist-recommendation/uploadToEeszt';
        return axios.post(url, params);
    }

    static getAllSpecialistRecommendationGyse(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/specialist-recommendation/gyse';
        return axios.get(url, params);
    }
    static saveSpecialistRecommendationGyse(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/specialist-recommendation/gyse';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/specialist-recommendation/gyse';
            return axios.post(url, params);
        }
    }
    static deleteSpecialistRecommendationGyse(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/specialist-recommendation/gyse?id=' + id;
        return axios.delete(url);
    }
    static unDeleteSpecialistRecommendationGyse(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/specialist-recommendation/gyse/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static uploadToEesztSpecialistRecommendationGyse(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/specialist-recommendation/gyse/uploadToEeszt';
        return axios.post(url, params);
    }
    static getSzakvKodok() {
        const url = process.env.VUE_APP_BACKEND_URL + '/specialist-recommendation/gyse/getSzakvKodok';
        return axios.get(url);
    }
    static getAllPuphaIso() {
        const url = process.env.VUE_APP_BACKEND_URL + '/specialist-recommendation/gyse/getAllPuphaIso';
        return axios.get(url);
    }
    ////////////////////

    // Public health care certificate
    static getAllPubHealthCareCert(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/public-health-care-certificate';
        return axios.get(url, params);
    }
    static savePubHealthCareCert(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/public-health-care-certificate';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/public-health-care-certificate';
            return axios.post(url, params);
        }
    }
    static deletePubHealthCareCert(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/public-health-care-certificate?id=' + id;
        return axios.delete(url);
    }
    static unDeletePubHealthCareCert(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/public-health-care-certificate/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static printPubHealthCareCert(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/public-health-care-certificate/print';
        return axios.get(url, params);
    }
    ////////////////////

    // Doctor magis template
    static getAllMagisTemplate(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorMagisTemplate';
        return axios.get(url, params);
    }
    static saveMagisTemplate(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/doctorMagisTemplate';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/doctorMagisTemplate';
            return axios.post(url, params);
        }
    }
    static deleteMagisTemplate(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorMagisTemplate?id=' + id;
        return axios.delete(url);
    }
    static unDeleteMagisTemplate(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorMagisTemplate/setUnDelete?id=' + id;
        return axios.post(url);
    }
    ////////////////////

    // Occupation health admin
    static getAllOccupationHealthPartner(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partner/listByPaging';
        return axios.get(url, params)
    }
    static saveOccupationHealthPartner(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partner';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partner';
            return axios.post(url, params);
        }
    }
    static changeOccupationHealthPartnerActivation(id, active) {
        if (active === 0) {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partner/deactivateOccupationHealthPartner/' + id;
            return axios.post(url);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partner/activateOccupationHealthPartner/' + id;
            return axios.post(url);
        }
    }
    static deleteOccupationHealthPartner(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partner?id=' + id;
        return axios.delete(url);
    }
    static unDeleteOccupationHealthPartner(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partner/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static listOccupationHealthPartnerByName(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient/getPartnerForPatient';
        return axios.get(url, params)
    }
    static listOccupationHealthPartnerSiteInfoByName(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient/getPartnerSiteForPatient';
        return axios.get(url, params)
    }
    static getAllOccupationHealthPartners(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partner/findAll';
        return axios.get(url, params)
    }
    static exportOccupationHealthPartner(partnerId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partner/exportPartner/' + partnerId;
        return axios.get(url);
    }
    static getExportStatus(progressId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partner/getExportStatus';
        return axios.get(url, {
            params: {
                progressId: progressId
            }
        });
    }

    static getAllOccupationHealthPartnerSiteContact(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteContact/listByPaging';
        return axios.get(url, params)
    }
    static saveOccupationHealthPartnerSiteContact(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteContact';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteContact';
            return axios.post(url, params);
        }
    }
    static deleteOccupationHealthPartnerSiteContact(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteContact?id=' + id;
        return axios.delete(url);
    }
    static unDeleteOccupationHealthPartnerSiteContact(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteContact/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static listOccupationHealthPartnerSiteContactByName(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteContact/selectByName';
        return axios.get(url, params)
    }
    static findAll2FAUserForFeuContact() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteContact/findAll2FAUserForFeuContact';
        return axios.get(url)
    }
    static saveFeuPartnerManagerUser(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/users/saveFeuPartnerManagerUser';
        return axios.post(url, params);
    }
    static saveUserToContact(contactId, userId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteContact/saveUserToContact';
        return axios.get(url, {
            params: {
                userId: userId,
                contactId: contactId
            }
        });
    }

    static getAllOccupationHealthPartnerSite(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partnerSite/listByPaging';
        return axios.get(url, params)
    }
    static saveOccupationHealthPartnerSite(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partnerSite';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partnerSite';
            return axios.post(url, params);
        }
    }
    static findByIdOccupationHealthPartnerSite(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partnerSite/findById/' + id;
        return axios.get(url);
    }
    static findByPartnerSiteIdOccupationHealthPartnerSite(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partnerSite/findPartnerSiteById?partnerSiteId=' + params.params.partnerSiteId;
        return axios.get(url);
    }
    static deleteOccupationHealthPartnerSite(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partnerSite?id=' + id;
        return axios.delete(url);
    }
    static unDeleteOccupationHealthPartnerSite(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partnerSite/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static listOccupationHealthPartnerSiteByName(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partnerSite/selectByName';
        return axios.get(url, params)
    }
    static getAllPartnersToSelect(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partner/getAllPartnersSelect';
        return axios.get(url, params)
    }
    static getPartnersByUserToSelect(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partner/selectByUser';
        return axios.get(url, params)
    }
    static getPartnerInfo(partnerId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partner/' + partnerId;
        return axios.get(url)
    }
    static moveEmployees(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroup/movePatient';
        return axios.post(url, params);
    }
    static movePatientInFEUPatientDetails(params, appointmentId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroup/movePatientDuringTreatment?appointmentId=' + appointmentId;
        return axios.post(url, params);
    }
    static saveAddPatientToPartnerModal(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroup/addPatient';
        return axios.post(url, params);
    }
    static movePatientFromDefault(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partnerSite/movePatientFromDefault';
        return axios.post(url, params);
    }
    static getGroupPatientData(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partnerSite/getGroupPatientData';
        return axios.get(url, params);
    }
    static modifyEmploymentRelationshipDate(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partnerSite/modifyEmploymentRelationshipDate';
        return axios.post(url, params);
    }
    static changeAppointmentOccuHeaPartnerSiteGroup(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/changeAppointmentOccuHeaPartnerSiteGroup';
        return axios.post(url, params);
    }
    static saveOccupationHealthPartnerSiteGroup(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroup';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroup';
            return axios.post(url, params);
        }
    }
    static findByIdOccupationHealthPartnerSiteGroup(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroup/findById/' + id;
        return axios.get(url)
    }
    static deleteOccupationHealthPartnerSiteGroup(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroup?id=' + id;
        return axios.delete(url);
    }
    static unDeleteOccupationHealthPartnerSiteGroup(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroup/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static getAllGroupBySiteLight(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroup/getAllGroupBySiteLight';
        return axios.get(url, params)
    }
    static getAllGroupBySiteWithDeleted(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroup/getAllGroupBySiteWithDeleted';
        return axios.get(url, params)
    }
    // static getAllGroup(params) {
    //     //ezt még finomítani kell
    //     const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroup/getAllGroup';
    //     return axios.get(url)
    // }

    static getOccupationHealthJobCategories() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=45600';
        return axios.get(url);
    }
    static getMolPartnerIds() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partner/getMolPartnerIds';
        return axios.get(url);
    }
    static getOccupationalHealthJobs() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/extended/feor/13500';
        return axios.get(url);
    }

    static getOccupationHealthJobBranchOfNationalEconomy() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=45700';
        return axios.get(url);
    }

    // Code store
    static getAllOccupationHealthCodeStore(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/listByPaging';
        return axios.get(url, params)
    }
    static saveOccupationHealthCodeStore(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore';
        return axios.post(url, params);
    }
    static deleteOccupationHealthCodeStore(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore?id=' + id;
        return axios.delete(url);
    }
    static listOccupationHealthCodeStoreByName(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/selectByName';
        return axios.get(url, params)
    }
    static getOccupationHealthCodeStoreTypes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/getCodeStoreTypes';
        return axios.get(url)
    }
    static getOccupationHealthCodeStoreByType(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/byType';
        return axios.get(url, params)
    }
    static getOccupationHealthLabTypes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/byType?csId=4';
        return axios.get(url)
    }

    // Referral
    static getAllOccupationHealthReferral(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/referral/listByPaging';
        return axios.get(url, params)
    }
    static findReferralByGroupPatientId(groupPatientId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/referral/findReferralByGroupPatientId/' + groupPatientId;
        return axios.get(url)
    }
    static validateReferralXlsx(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupation-health-referral-loader/validate';
        return axios.post(url, params);
    }
    static saveValidatedReferralXlsx(params, queryParams) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupation-health-referral-loader/xls?email=' + queryParams.email;
        return axios.post(url, params);
    }
    static getDownloadableReferralXlsxTemplate() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupation-health-referral-loader/downloadTemplate';
        return axios.get(url);
    }
    static findReferralById(referralId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/referral/findReferralById/' + referralId;
        return axios.get(url)
    }
    static saveOccupationHealthReferral(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/referral';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/referral';
            return axios.post(url, params);
        }
    }
    static deleteOccupationHealthReferral(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/referral?id=' + id;
        return axios.delete(url);
    }
    static unDeleteOccupationHealthReferral(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/referral/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static setUsedOccupationHealthReferral(id, attendanceId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/referral/setToUsed/' + id + '/' + attendanceId;
        return axios.get(url);
    }
    static getReferralDocument(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/referral/printReferral/' + id;
        return axios.get(url);
    }
    static getUserOccupationHealthPartners() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partner/getUserOccupationHealthPartners';
        return axios.get(url);
    }
    static getReferralTypes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/byType?csId=13';
        return axios.get(url)
    }
    static saveWithDocument(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/referral/saveWithDocument';
        return axios.post(
            url,
            params,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    }

    // Restriction
    static getAllOccupationHealthRestriction(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/restriction/listByPaging';
        return axios.get(url, params)
    }
    static getAllOccupationHealthEmployabilityRestrictions() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/restriction/findAllEmployabilityRestriction';
        return axios.get(url)
    }
    static getAllOccupationHealthRestrictionForSelect() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/restriction/getAllRestrictionForSelect';
        return axios.get(url)
    }
    static getAllPrimaryOccupationHealthRestrictionForSelect() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/restriction/getAllPrimaryRestrictionForSelect';
        return axios.get(url)
    }
    static getAllOccupationHealthRestrictionForMenu(currentPage, perPage, restrictionFilterParams, withDeleted) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/restriction/listByPagingForMenu?pageIndex=' + currentPage + '&pageSize=' + perPage + '&withDeleted=' + withDeleted;
        const params = {
            filter: restrictionFilterParams
        };
        return axios.get(url, { params: params }
        )
    }
    static getAllOccupationalHealthRestrictionDifferences(currentPage, perPage, restrictionId, differenceFilterParams, withDeleted) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/restriction/listAnomaliesByPaging?parentId=' + restrictionId + '&pageIndex=' + currentPage + '&pageSize=' + perPage + '&withDeleted=' + withDeleted;
        const params = {
            filter: differenceFilterParams
        };
        return axios.get(url, { params: params })
    }
    static saveOccupationHealthRestriction(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/restriction';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/restriction';
            return axios.post(url, params);
        }
    }
    static saveOccupationHealthRestrictionDifference(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/restriction';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/restriction/saveAnomaly';
            return axios.post(url, params);
        }
    }
    static deleteOccupationHealthRestriction(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/restriction?id=' + id;
        return axios.delete(url);
    }
    static deleteOccupationHealthDifference(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/restriction/deleteAnomaly?id=' + id;
        return axios.delete(url);
    }
    static unDeleteOccupationHealthRestriction(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/restriction/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static unDeleteOccupationHealthDifference(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/restriction/setUnDeleteAnomaly?id=' + id;
        return axios.post(url);
    }

    static listOccupationHealthRestrictionByName(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/restriction/listByPaging';
        return axios.get(url, params)
    }

    // Vaccination
    static getAllOccupationHealthVaccination(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/vaccination/listByPaging';
        return axios.get(url, params)
    }
    static saveOccupationHealthVaccination(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/vaccination';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/vaccination';
            return axios.post(url, params);
        }
    }
    static deleteOccupationHealthVaccination(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/vaccination?id=' + id;
        return axios.delete(url);
    }
    static unDeleteOccupationHealthVaccination(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/vaccination/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static listOccupationHealthVaccinationByName(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/vaccination/selectByName';
        return axios.get(url, params)
    }
    //Felettesek - SuperVisors
    static getAllSuperVisors(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/supervisor/listByPaging';
        return axios.get(url, params)
    }
    static getSupervisorSiteGroupPatients(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/supervisor/getSupervisorSiteGroupPatients';
        return axios.get(url, params)
    }
    static getSupervisorSiteGroupPatientAssignments(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/supervisor/getSupervisorSiteGroupPatientAssignments';
        return axios.get(url, params)
    }
    static assignSupervisorToGroupPatients(params, supervisorId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/supervisor/assignSupervisorToGroupPatients?supervisorId=' + supervisorId;
        return axios.put(url, params);
    }
    static saveSupervisor(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/supervisor/' + params.id;
            return axios.put(url, params)
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/supervisor';
            return axios.post(url, params);
        }
    }
    static getSupervisorInfo(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/supervisor/' + id;
        return axios.get(url);
    }
    static deleteSupervisor(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/supervisor/softDelete?id=' + id;
        return axios.delete(url);
    }
    static deletePatientFromSupervisor(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/supervisor/deleteSiteGroupPatientFromSupervisor?siteGroupPatientId=' + params.id + '&supervisorId=' + params.supervisorId + '&partnerId=' + params.partnerId;
        return axios.delete(url, params);
    }
    static unDeleteSupervisor(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/supervisor/softUndelete?id=' + id;
        return axios.delete(url);
    }
    static assignSupervisorToPatients(params, supervisorId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/supervisor/assignSupervisorToPatients?supervisorId=' + supervisorId;
        return axios.put(url, params)
    }
    static getPatientsForSupervisor(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/supervisor/getPatientsForSupervisor';
        return axios.get(url, params)
    }
    static getAssignablePatientsForSupervisor(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/supervisor/getAssignablePatientsForSupervisor';
        return axios.get(url, params);
    }
    static getSupervisorsForSite(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/supervisor/getSupervisorsForSite';
        return axios.get(url, params);
    }
    static getSupervisorsForSelect(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/supervisor/getSupervisorsForPartnerId';
        return axios.get(url, params);
    }
    // Exposure'
    static getAllOccupationHealthExposure(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/listByPaging';
        return axios.get(url, params)
    }
    static saveOccupationHealthExposure(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure';
            return axios.post(url, params);
        }
    }
    static deleteOccupationHealthExposure(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure?id=' + id;
        return axios.delete(url);
    }
    static unDeleteOccupationHealthExposure(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static listOccupationHealthExposureByName(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/selectByName';
        return axios.get(url, params)
    }

    static getAllOccupationHealthExposureProtocol(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/listByPaging';
        return axios.get(url, params)
    }
    static saveOccupationHealthExposureProtocol(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol';
            return axios.post(url, params);
        }
    }
    static deleteOccupationHealthExposureProtocol(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol?id=' + id;
        return axios.delete(url);
    }
    static unDeleteOccupationHealthExposureProtocol(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static getStandProtocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getStandProtocol';
        return axios.get(url);
    }
    static getWholeBodyVibrationProtocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getWholeBodyVibrationProtocol';
        return axios.get(url);
    }
    static getLoadByPersonalProtectiveEquipmentProtocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getLoadByPersonalProtectiveEquipmentProtocol';
        return axios.get(url);
    }
    static getNightShiftWorkProtocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getNightShiftWorkProtocol';
        return axios.get(url);
    }
    static getErgonomicFactorsProtocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getErgonomicFactorsProtocol';
        return axios.get(url);
    }
    static getRiskOfInfectionProtocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getRiskOfInfectionProtocol';
        return axios.get(url);
    }
    static getIncreasedRiskOfAccidentProtocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getIncreasedRiskOfAccidentProtocol';
        return axios.get(url);
    }
    static getIncreasedMentalLoadProtocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getIncreasedMentalLoadProtocol';
        return axios.get(url);
    }
    static getLocallyActingVibrationProtocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getLocallyActingVibrationProtocol';
        return axios.get(url);
    }
    static getIonizingRadiationProtocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getIonizingRadiationProtocol';
        return axios.get(url);
    }
    static getWalkingProtocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getWalkingProtocol';
        return axios.get(url);
    }
    static getPriorityJobInEpidemiologicalInterestProtocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getPriorityJobInEpidemiologicalInterestProtocol';
        return axios.get(url);
    }
    static getForcedBodyPositionProtocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getForcedBodyPositionProtocol';
        return axios.get(url);
    }
    static getWorkInFrontOfScreenProtocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getWorkInFrontOfScreenProtocol';
        return axios.get(url);
    }
    static getManualMaterialHandlingProtocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getManualMaterialHandlingProtocol';
        return axios.get(url);
    }
    static getNonIonizingRadiationProtocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getNonIonizingRadiationProtocol';
        return axios.get(url);
    }
    static getPowdersProtocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getPowdersProtocol';
        return axios.get(url);
    }
    static getPsychosocialProtocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getPsychosocialProtocol';
        return axios.get(url);
    }
    static getHeavyWorkplaceCimateProtocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getHeavyWorkplaceCimateProtocol';
        return axios.get(url);
    }
    static getSeatProtocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getSeatProtocol';
        return axios.get(url);
    }
    static getChemicalsProtocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getChemicalsProtocol';
        return axios.get(url);
    }
    static getNoiseProtocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getNoiseProtocol';
        return axios.get(url);
    }


    static getKeziAnyag520Protocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getKeziAnyag520Protocol';
        return axios.get(url);
    }
    static getKeziAnyag2050Protocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getKeziAnyag2050Protocol';
        return axios.get(url);
    }
    static getKeziAnyag50Protocol() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/exposure/protocol/getKeziAnyag50Protocol';
        return axios.get(url);
    }



    ////////////////////

    // Egyéb vizsgálati dokumentumok ellátásokban/alapadatokban
    static getAdditionalExaminationForPatientAttendanceDetails(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/labHandle/listOccHeaLabsByPatientId';
        return axios.get(url, params);
    }
    static saveAdditionalExamination(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/labHandle';
        return axios.post(url, params);
    }
    static deleteAdditionalExamination(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/labHandle?id=' + id;
        return axios.delete(url);
    }
    static unDeleteAdditionalExamination(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/labHandle/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static getAdditionalExaminationDocument(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/labHandle/downloadLab/' + id;
        return axios.get(url);
    }
    static sendAdditionalExaminationDocument(labId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/labHandle/sendLabDocument/' + labId;
        return axios.get(url);
    }
    ////////////////////
    //Employability form
    //restrictions

    //
    static getSapRiports(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/VDetailedOccHeaReport/listByPaging';
        return axios.get(url, params);
    }

    // Occupation health riport
    // Employability opinion
    //Alkalmassági vélemény
    //static getEmployabilityOpinionByPatient(params) {

    static getOccupationHealthEmployabilityDetails(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/occupationHealthEmployability/findById?id=' + id;
        return axios.get(url);
    }
    static getOccupationHealthEmployabilityOpinionDetails(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/employabilityOpinion/findById?id=' + id;
        return axios.get(url);
    }
    static validateByEmployability(employabilityId, typeId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/validateByEmployability?employabilityId=' + employabilityId + '&typeId=' + typeId;
        return axios.post(url);
    }
    static validateByOpinion(opinionId, typeId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/validateByOpinion?opinionId=' + opinionId + '&typeId=' + typeId;
        return axios.post(url);
    }

    static getEmployabilityOpinionByPatient(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/employabilityOpinion/listOpinionPaging';
        return axios.get(url, params);
    }
    //Záróvizsgálati eredmény
    static getFinalExaminationResultByPatient(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/employabilityOpinion/listFinalExamPaging';
        return axios.get(url, params);
    }
    static deleteEmployabilityOpinion(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/employabilityOpinion?id=' + id;
        return axios.delete(url);
    }
    static unDeleteEmployabilityOpinion(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/employabilityOpinion/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static saveEmployabilityOpinion(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/employabilityOpinion';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/employabilityOpinion';
            return axios.post(url, params);
        }
    }
    static getCapableStatus() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=45000';
        return axios.get(url);
    }
    static getCapableStatusFiltered() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/capableStatusFiltered';
        return axios.get(url);
    }
    static getCapableStatusFilteredToCapableAndNotCapable() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/getCapableStatusFilteredToCapableAndNotCapable';
        return axios.get(url);
    }
    static printEmployabilityOpinionDocument(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/employabilityOpinion/print/' + id;
        return axios.get(url);
    }
    static printEmployabilityOpinionDocumentDraft(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/employabilityOpinion/printDraft?documentId=' + id;
        return axios.get(url);
    }
    static printDraftFinalExam(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/occupationHealthEmployability/printDraftFinalExam?documentId=' + id;
        return axios.get(url);
    }
    static printDraftFinalExamResult(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/employabilityOpinion/printDraftFinalExam?documentId=' + id;
        return axios.get(url);
    }
    static saveAndPrintEmployabilityOpinion(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/employabilityOpinion/saveAndPrint';
        return axios.post(url, params);
    }
    static saveEmployabilityAndOpinion(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/occupationHealthEmployability/saveEmployabilityAndOpinion';
        return axios.post(url, params);
    }
    static saveAndValidateEmployabilityAndOpinion(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/occupationHealthEmployability/saveAndValidateEmployabilityAndOpinion';
        return axios.post(url, params);
    }
    static saveEmployabilityAndOpinionWithLicense(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/occupationHealthEmployability/saveEmployabilityAndOpinionAndLicenses';
        return axios.post(url, params);
    }
    static saveAndValidateEmployabilityAndOpinionWithLicense(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/occupationHealthEmployability/saveAndValidateEmployabilityAndOpinionAndLicenses';
        return axios.post(url, params);
    }
    static sendOpinionToPatient(queryParams) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/employabilityOpinion/sendOpinionToPatient?opinionId=' + queryParams.opinionId
        return axios.post(url);
    }
    static sendOpinionToSupervisor(queryParams) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/employabilityOpinion/sendOpinionToSupervisor?opinionId=' + queryParams.opinionId
        return axios.post(url);
    }
    // Employability
    static isAllReopenedDocValidated(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/isAllReopenedDocValidated';
        return axios.get(url, params);
    }
    //Munkalkalmassági
    static getEmployabilityByPatient(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/occupationHealthEmployability/listEmployabilityByPaging';
        return axios.get(url, params);
    }
    static getPartnerInfoByPatient(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient/getOInfoForPatientNew'
        return axios.get(url, params);
    }
    static getPartnerActivationState(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partner/isOccupationHealthPartnerActive/' + id
        return axios.get(url);
    }
    //Záróvizsgálat
    static getFinalExaminationByPatient(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/occupationHealthEmployability/listFinalExamByPaging';
        return axios.get(url, params);
    }
    static deleteEmployability(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/occupationHealthEmployability?id=' + id;
        return axios.delete(url);
    }
    static unDeleteEmployability(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/occupationHealthEmployability/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static saveEmployability(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/occupationHealthEmployability';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/occupationHealthEmployability';
            return axios.post(url, params);
        }
    }
    static printEmployabilityDocument(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/occupationHealthEmployability/print/' + id;
        return axios.get(url);
    }
    static printEmployabilityDocumentDraft(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/occupationHealthEmployability/printDraft?documentId=' + id;
        return axios.get(url);
    }
    static saveAndPrintEmployability(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/occupationHealthEmployability/saveAndPrint';
        return axios.post(url, params);
    } ve
    static getEmployabilityTypes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/byType?csId=9';
        return axios.get(url)
    }
    static getFireArmEmployabilityTypes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/getFireArmEmployabilityTypes';
        return axios.get(url)
    }
    static getNegativeTemplate(patientId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/occupationHealthEmployability/getNegativeTemplateByPatient/' + patientId;
        return axios.get(url)
    }
    static getLastEmployability(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/occupationHealthEmployability/getPatientLatestEmployability';
        return axios.get(url, params)
    }
    static saveNegativeTemplate(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/occupationHealthEmployability/saveNegativeTemplate';
        return axios.post(url, params);
    }
    ////////////////////

    // Employability doctor template
    static findAllOccupationHealthDoctors() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/employabilityDoctorTemplate/findAllOccupationHealthDoctors';
        return axios.get(url)
    }
    static getAllOccupationHealthDoctorTemplate(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/employabilityDoctorTemplate/listByPaging';
        return axios.get(url, params)
    }
    static getOccupationHealthDoctorTemplateByType(typeId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/employabilityDoctorTemplate/getByTypeId?typeId=' + typeId;
        return axios.get(url)
    }
    static saveOccupationHealthDoctorTemplate(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/employabilityDoctorTemplate';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/employabilityDoctorTemplate';
            return axios.post(url, params);
        }
    }
    static deleteOccupationHealthDoctorTemplate(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/employabilityDoctorTemplate?id=' + id;
        return axios.delete(url);
    }
    static unDeleteOccupationHealthDoctorTemplate(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/employabilityDoctorTemplate/setUnDelete?id=' + id;
        return axios.post(url);
    }
    ////////////////////

    // Firearms permit
    static getOccupationHealthFirearmPermitByPatient(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/firearmPermit/listByPaging';
        return axios.get(url, params);
    }
    static deleteOccupationHealthFirearmPermit(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/firearmPermit?id=' + id;
        return axios.delete(url);
    }
    static unDeleteOccupationHealthFirearmPermit(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/firearmPermit/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static saveOccupationHealthFirearmPermit(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/firearmPermit';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/firearmPermit';
            return axios.post(url, params);
        }
    }
    static printOccupationHealthFirearmPermitDocument(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/firearmPermit/print/' + id;
        return axios.get(url);
    }
    static printOccupationHealthFirearmPermitDocumentOpinion(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/firearmPermit/printOpinion/' + id;
        return axios.get(url);
    }
    static saveAndPrintOccupationHealthFirearmPermit(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/firearmPermit/saveAndPrint';
        return axios.post(url, params);
    }
    static saveAndValidateOccupationHealthFirearmPermit(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/firearmPermit/saveValidateAndPrint';
        return axios.post(url, params);
    }
    static validateFirearmPermit(firearmPermitId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/validateFirearmPermit?firearmPermitId=' + firearmPermitId;
        return axios.post(url);
    }
    static reOpenFirearmPermit(firearmPermitId, reason) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/reOpenFirearmPermit?firearmPermitId=' + firearmPermitId + '&reOpenReason=' + reason;
        return axios.post(url);
    }
    static getFirearmPermitHistory(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/getFirearmPerimtHistory';
        return axios.get(url, params);
    }
    static rollbackFirearmPermitVersion(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/rollbackFirearmPermit?documentId=' + id;
        return axios.post(url);
    }
    static printFirearmPermitDocumentDraft(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/firearmPermit/printDraft?documentId=' + id;
        return axios.get(url);
    }
    ////////////////////

    // Driver license
    static getOccupationHealthDriverLicenseById(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/driverLicense/findById?id=' + id;
        return axios.get(url);
    }
    static getDriverLicenseRestrictionIdsWithLetterCodes() {
        const url = process.env.VUE_APP_BACKEND_URL + "/occupationHealth/codeStore/getDriverLicenseRestrictionIdsWithLetterCodes";
        return axios.get(url);
    }
    static getOccupationHealthDriverLicenseByPatient(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/driverLicense/listByPaging';
        return axios.get(url, params);
    }
    /*static deleteOccupationHealthDriverLicense(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/driverLicense?id=' + id;
        return axios.delete(url);
    }*/
    static deleteOccupationHealthDriverLicense(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/driverLicense';
        return axios.delete(url, { params: params });
    }
    static unDeleteOccupationHealthDriverLicense(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/driverLicense/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static saveOccupationHealthDriverLicense(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/driverLicense';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/driverLicense';
            return axios.post(url, params);
        }
    }
    static getOccupationHealthDriverLicenseHistory(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/getDriversLicenseHistory';
        return axios.get(url, params);
    }
    static sendOccupationHealthDriverLicenseToEESZT(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/driverLicense/sendToEeszt';
        return axios.get(url, {
            params: {
                id: id
            }
        });
    }
    static deleteOccupationHealthDriverLicenseFromEESZT(id, reason) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/driverLicense/deleteFromEeszt';
        return axios.delete(url, {
            params: {
                id: id,
                megjegyzes: reason
            }
        });
    }
    static getOccupationHealthDriverLicenceDocumentFromEEESZT(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/driverLicense/printEeszt/' + id;
        return axios.get(url);
    }
    static getOccupationHealthDriverLicenceKezbesitesiIgazolasDocumentFromEEESZT(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/driverLicense/printEesztKezbVeze';
        return axios.get(url, {
            params: {
                id: id,
                type: "KEZB"
            }
        });
    }
    static getOccupationHealthDriverLicenceVezetoiEngedelyDocumentFromEEESZT(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/driverLicense/printEesztKezbVeze';
        return axios.get(url, {
            params: {
                id: id,
                type: "VEZE"
            }
        });
    }
    static printOccupationHealthDriverLicenseDocument(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/driverLicense/print/' + id;
        return axios.get(url);
    }
    static saveAndPrintOccupationDriverLicensePermit(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/driverLicense/saveAndPrint';
        return axios.post(url, params);
    }
    static saveAndPrintAndValidateOccupationDriverLicensePermit(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/driverLicense/saveAndPrintAndValidate';
        return axios.post(url, params);
    }
    static validateDriversLicense(driversLicenseId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/validateDriversLicense?driversLicenseId=' + driversLicenseId;
        return axios.post(url);
    }
    static reopenDriversLicense(driversLicenseId, reOpenReason) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/reOpenDriversLicense?driversLicenseId=' + driversLicenseId + '&reOpenReason=' + reOpenReason;
        return axios.post(url);
    }
    static rollBackDriverLicense(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/rollbackDriversLicense?documentId=' + id;
        return axios.post(url);
    }
    static getDriverLicenseLevels() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/byType?csId=11';
        return axios.get(url);
    }
    static getDriverLicenseExaminationGoals() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/byType?csId=15';
        return axios.get(url);
    }
    static getDriverLicenseExaminationTypes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/byType?csId=16';
        return axios.get(url);
    }
    static getDriverLicenseLetterCodes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/byType?csId=17';
        return axios.get(url);
    }
    static getDriverLicenseRestrictions() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/byType?csId=19';
        return axios.get(url);
    }
    static getDriverLicenseRestrictionsSorted() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/getDriverLicenseRestrictions';
        return axios.get(url);
    }
    static getDriverLicenseTypes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/byType?csId=22';
        return axios.get(url);
    }
    static getFirearmLicenseTypes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/byType?csId=27';
        return axios.get(url);
    }
    static getDriverLicenseOpinionTypes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/byType?csId=12';
        return axios.get(url);
    }

    static getBoatLicenseListForPatient(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/boatLicense/listByPaging';
        return axios.get(url, params);
    }
    static getBoatLicenseListForPatientById(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/boatLicense/findById?id=' + id;
        return axios.get(url);
    }
    static saveBoatLicense(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/boatLicense';
        return axios.post(url, params);
    }
    static saveAndPrintBoatLicense(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/boatLicense/saveAndPrint';
        return axios.post(url, params);
    }
    static saveAndPrintAndValidateBoatLicense(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/boatLicense/saveAndPrintAndValidate';
        return axios.post(url, params);
    }
    static deleteBoatLicense(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/boatLicense';
        return axios.delete(url, { params: { id } });
    }
    static unDeleteBoatLicense(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/boatLicense/setUnDelete';
        return axios.delete(url, { params: { id } });
    }
    static getBoatLicenseRestrictions() {
        const url = process.env.VUE_APP_BACKEND_URL + "/occupationHealth/codeStore/getBoatLicenseRestrictions";
        return axios.get(url);
    }
    static validateBoatLicense(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/validateBoatLicense?boatLicenseId=' + id;
        return axios.post(url);
    }
    static reopenBoatLicense(boatLicenseId, reOpenReason) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/reOpenBoatLicense?boatLicenseId=' + boatLicenseId + '&reOpenReason=' + reOpenReason;
        return axios.post(url);
    }
    static rollbackBoatLicense(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/rollbackBoatLicense?documentId=' + id;
        return axios.post(url);
    }
    static getBoatLicenseHistory(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/getBoatLicenseHistory';
        return axios.get(url, params);
    }
    static printDraftDocument(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/printDraft?documentId=' + id;
        return axios.get(url);
    }
    static printBoatLicense(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/boatLicense/print/' + id;
        return axios.get(url)
    }

    // MachineOperator
    static getOccupationHealthMachineOperatorByPatient(params) {
        const url =
            process.env.VUE_APP_BACKEND_URL +
            "/occupationHealth/machineOperationLicense/listByPaging";
        return axios.get(url, params);
    }

    static getOccupationHealthMachineOperatorCategories() {
        const url =
            process.env.VUE_APP_BACKEND_URL +
            "/occupationHealth/codeStore/byCsId?csId=26";
        return axios.get(url);
    }

    static getOccupationHealthMachineOperatorById(id) {
        const url =
            process.env.VUE_APP_BACKEND_URL +
            "/occupationHealth/machineOperationLicense/findById?id=" +
            id;
        return axios.get(url);
    }

    static saveOccupationHealthMachineOperator(params) {
        const url =
            process.env.VUE_APP_BACKEND_URL +
            "/occupationHealth/machineOperationLicense";
        return axios.post(url, params);
    }

    static saveAndPrintAndValidateMachineOperator(params) {
        const url =
            process.env.VUE_APP_BACKEND_URL +
            "/occupationHealth/machineOperationLicense/saveAndPrintAndValidate";
        return axios.post(url, params);
    }

    static deleteOccupationHealthMachineOperator(id) {
        const url =
            process.env.VUE_APP_BACKEND_URL +
            "/occupationHealth/machineOperationLicense?id=" +
            id;
        return axios.delete(url);
    }

    static unDeleteOccupationHealthMachineOperator(id) {
        const url =
            process.env.VUE_APP_BACKEND_URL +
            "/occupationHealth/machineOperationLicense/setUnDelete?id=" +
            id;
        return axios.delete(url);
    }

    static validateOccupationHealthMachineOperator(id) {
        const url =
            process.env.VUE_APP_BACKEND_URL +
            "/medDocument/validateMachineOperationLicense?machineOperationLicenseId=" +
            id;
        return axios.post(url);
    }

    static reOpenOccupationHealthMachineOperator(id, reOpenReason) {
        const url =
            process.env.VUE_APP_BACKEND_URL +
            "/medDocument/reOpenMachineOperationLicense?machineOperationLicenseId=" +
            id +
            "&reOpenReason=" +
            reOpenReason;
        return axios.post(url);
    }

    static rollBackOccupationHealthMachineOperator(id) {
        const url =
            process.env.VUE_APP_BACKEND_URL +
            "/medDocument/rollbackMachineOperationLicense?documentId=" +
            id;
        return axios.post(url);
    }

    static getMachineOperatorHistory(params) {
        const url =
            process.env.VUE_APP_BACKEND_URL +
            "/medDocument/getMachineOperationLicenseHistory";
        return axios.get(url, params);
    }

    static printMachineOperatorLicense(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/machineOperationLicense/print/' + id;
        return axios.get(url)
    }

    ////////////////////

    //PatientAllergies
    static getAllergiesForPatient(patientId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-allergies/getAllergiesByPatient/' + patientId;
        return axios.get(url)
    }
    static saveAllergiesForPatient(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-allergies/save';
        return axios.post(url, params)
    }

    //PatientVaccination
    static getVaccinationByPatient(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthVaccinationPatient/listByPaging?'
        return axios.get(url, params);
    }
    static getVaccinationById(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthVaccinationPatient/' + id;
        return axios.get(url);
    }
    static saveVaccinationForPatient(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthVaccinationPatient/update'
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthVaccinationPatient/insert';
            return axios.put(url, params);
        }
    }
    static deleteVaccination(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthVaccinationPatient/delete?id=' + id;
        return axios.delete(url);
    }
    // Medical record sheet
    static getIllnessesForPatient(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/occupation/bytype?csId=21'
        return axios.get(url, params);
    }
    static getMedicalRecordSheetByPatient(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/medicalRecordSheet/listByPaging';
        return axios.get(url, params);
    }
    static getAllEatingHabits(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/byType?csId=20';
        return axios.get(url, params);
    }
    static deleteMedicalRecordSheet(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/medicalRecordSheet?id=' + id;
        return axios.delete(url);
    }
    static unDeleteMedicalRecordSheet(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/medicalRecordSheet/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static getMedicalRecordSheetByPatientId(patientId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/medicalRecordSheet/getByPatientId/' + patientId;
        return axios.get(url);
    }
    static saveMedicalRecordSheet(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/medicalRecordSheet';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/medicalRecordSheet';
            return axios.post(url, params);
        }
    }
    static printMedicalRecordSheetDocument(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/medicalRecordSheet/print/' + id;
        return axios.get(url);
    }
    static saveAndPrintMedicalRecordSheet(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/medicalRecordSheet/saveAndPrint';
        return axios.post(url, params);
    }
    static getSportHabitTypes(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=45100';
        return axios.get(url, params);
    }
    static getEatingHabitTypes(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=45200';
        return axios.get(url, params);
    }
    static getBacterias() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/byType?csId=5';
        return axios.get(url)
    }
    static getViruses() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/byType?csId=6';
        return axios.get(url)
    }
    static getParasites() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/byType?csId=7';
        return axios.get(url)
    }
    static getMushrooms() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/byType?csId=8';
        return axios.get(url)
    }
    static getAllergicHypersensitivities() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/byType?csId=1';
        return axios.get(url)
    }
    static getDiseasesSurgeriesAccidents() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/byType?csId=2';
        return axios.get(url)
    }
    static getOperations() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/byType?csId=14';
        return axios.get(url)
    }
    static getTakingDrugs() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/codeStore/byType?csId=3';
        return axios.get(url)
    }
    ////////////////////

    // Occupation health report
    static getFilterOperators() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=45500';
        return axios.get(url);
    }
    static getMedicalRecordSheetForReport(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReportReport/medicalRecordSheetReport';
        return axios.get(url, params);
    }
    // Report config
    static getOccupationHealthReportConfigByUser(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReportConfig/listByPaging';
        return axios.get(url, params);
    }
    static deleteOccupationHealthReportConfig(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReportConfig?id=' + id;
        return axios.delete(url);
    }
    static unDeleteOccupationHealthReportConfig(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReportConfig/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static saveOccupationHealthReportConfig(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReportConfig';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReportConfig';
            return axios.post(url, params);
        }
    }

    static getYearlyReport(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReportReport/yearlyReport';
        return axios.get(url, params);
    }
    static getCategoryReport(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReportReport/categoryReport';
        return axios.get(url, params);
    }
    static exportYearlyReport(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReportReport/exportYearlyReport';
        return axios.post(url, params);
    }
    static exportCategoryReport(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReportReport/exportCategoryReport';
        return axios.get(url, params);
    }

    static occupationHealthEmployabilityReport(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReportReport/occupationHealthEmployabilityReport';
        return axios.get(url, params);
    }

    static occupationHealthEmployabilityReportAlternative(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReportReport/feuPartnerReport';
        return axios.get(url, params);
    }

    static occupationHealthEmployabilityReportNew(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReportReport/employabilityReport';
        return axios.get(url, params);
    }
    static feuTreatmentReport(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReportReport/feuTreatmentReport';
        return axios.get(url, params);
    }

    static occupationHealthLabReport(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReportReport/occupationHealthLabReport';
        return axios.get(url, params);
    }

    static occupationHealthVaccinationReport(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReportReport/occupationHealthVaccinationReport';
        return axios.get(url, params);
    }

    static occupationHealthTreatmentsDailyReport(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReportReport/occupationHealthTreatmentsDailyReport';
        return axios.get(url, params);
    }
    static occupationHealthTreatmentsMonthlyReport(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReportReport/occupationHealthTreatmentsMonthlyReport';
        return axios.get(url, params);
    }
    static occupationHealthTreatmentsYearlyReport(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReportReport/occupationHealthTreatmentsYearlyReport';
        return axios.get(url, params);
    }
    ////////////////////

    // szamlazz.hu
    static getAfaTipusList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/szamlazz/assets/getAfaTipusList';
        return axios.get(url);
    }
    static getSzamlaNyelvList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/szamlazz/assets/getSzamlaNyelvList';
        return axios.get(url);
    }
    static getFizetesiModList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/szamlazz/assets/getFizetesiModList';
        return axios.get(url);
    }
    static getFizetesiModListToSelect() {
        const url = process.env.VUE_APP_BACKEND_URL + '/szamlazz/assets/getFizetesiModListToSelect';
        return axios.get(url);
    }
    static getSzamlaszamElotagList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/szamlazz/assets/getSzamlaszamElotagList';
        return axios.get(url);
    }
    static getAdoalanyList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/szamlazz/assets/getAdoalanyList';
        return axios.get(url);
    }
    static findAppointmentByIdToInvoiceForm(appointmentId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/findAppointmentByIdToInvoiceForm/' + appointmentId;
        return axios.get(url);
    }
    static createInvoice(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/szamlazz/invoice/createInvoice';
        return axios.post(url, params);
    }
    static regenerateBillableSingle(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-coding-treatment/reGenerateBillable?id=' + id;
        return axios.post(url);
    }
    static regenerateBillableContributionSingle(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-coding-treatment/restoreInsurancePartnerBillable?id=' + id;
        return axios.post(url);
    }
    static regenerateBillableGroup(treatmentId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-coding-treatment/reGenerateBillableGroup?treatmentId=' + treatmentId;
        return axios.post(url);
    }
    static deleteBillableGroup(id, reason) {
        const url = process.env.VUE_APP_BACKEND_URL + '/billable/deleteGroup?id=' + id + '&reason=' + reason;
        return axios.delete(url);
    }
    static deleteBillableSingle(id, reason) {
        const url = process.env.VUE_APP_BACKEND_URL + '/billable/delete?id=' + id + '&reason=' + reason;
        return axios.delete(url);
    }
    static stornoInvoice(invoiceNumber) {
        const url = process.env.VUE_APP_BACKEND_URL + '/szamlazz/invoice/stornoInvoice';
        return axios.get(url, invoiceNumber);
    }
    static getInvoicePdf(invoiceNumber) {
        const url = process.env.VUE_APP_BACKEND_URL + '/szamlazz/invoice/getInvoicePdf';
        return axios.get(url, invoiceNumber);
    }
    static getInvoiceXmlData(invoiceNumber) {
        const url = process.env.VUE_APP_BACKEND_URL + '/szamlazz/invoice/getInvoiceXmlData';
        return axios.get(url, invoiceNumber);
    }
    ////////////////////
    // Backoffice
    // Customer list
    static saveCustomerList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/backoffice/customerList';
        return axios.post(url, params);
    }
    static getCustomerList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/backoffice/customerList/listByPaging';
        return axios.get(url, params);
    }
    static deleteCustomer(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/backoffice/customerList?id=' + id;
        return axios.delete(url);
    }
    static undeleteCustomer(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/backoffice/customerList/undelete?id=' + id;
        return axios.delete(url);
    }
    static selectUsedCustomer(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/backoffice/customerList/selectData';
        return axios.delete(url, params);
    }
    static getAdoalanyListForCustomers() {
        const url = process.env.VUE_APP_BACKEND_URL + '/szamlazz/assets/getAdoalanyList';
        return axios.get(url);
    }
    // Backoffice

    //PriceList
    static getPriceLists(params, currentPage, perPage) {
        const url = process.env.VUE_APP_BACKEND_URL + '/priceList/getDefaultPriceList?pageIndex=' + currentPage + '&pageSize=' + perPage;
        return axios.post(url, params)
    }
    static getPriceListsById(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/priceList/getPriceListWithId?id=' + id;
        return axios.get(url)
    }
    static getAllPriceLists(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/priceList/getAllPriceList';
        return axios.get(url, params)
    }
    static getAllPriceListsForSelect() {
        const url = process.env.VUE_APP_BACKEND_URL + '/priceList/priceListSelect';
        return axios.get(url)
    }
    static getAllLabPriceListsForSelect() {
        const url = process.env.VUE_APP_BACKEND_URL + '/labPriceList/priceListSelect';
        return axios.get(url)
    }
    static filterPriceLists(filterParams) {
        const url = process.env.VUE_APP_BACKEND_URL + '/priceList/filter'
        return axios.post(url, filterParams);
    }
    static generatePriceList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/priceList/generateNew';
        return axios.get(url)
    }
    static deletePriceList(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/priceList/delete?id=' + id;
        return axios.delete(url);
    }
    static undeletePriceList(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/priceList/undelete?id=' + id;
        return axios.delete(url);
    }
    static savePriceLists(data) {
        const url = process.env.VUE_APP_BACKEND_URL + '/priceList/save';
        return axios.post(url, data);
    }
    // Invoice list

    //CodedTreatments
    static getTreatmentTypesForCodedTreatments() {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-coding-treatment/getTreatmentTypes';
        return axios.get(url);
    }
    static getCodedTreatmentsListByRow(rowId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-coding-treatment/getCodedTreatmentsForRow?rowId=' + rowId;
        return axios.get(url);
    }
    static filterCodedTreatments(filterParams) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-coding-treatment/filter'
        return axios.post(url, filterParams);
    }
    static saveModifiedCodedTreatments(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-coding-treatment/modifyCodingTreatments';
        return axios.put(url, params);
    }
    static getTreatments(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-coding-treatment/listByPaging';
        return axios.get(url, params);
    }
    static getAllCodedTreatments(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-coding-treatment/listByPaging';
        return axios.get(url, params)
    }
    static getCodedTreatmentsDeleteByPatient(treatmentId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-coding-treatment/deleteGroup?treatmentId=' + treatmentId;
        return axios.delete(url)
    }
    static getCodedTreatmentsUnDeleteByPatient(treatmentId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-coding-treatment/undeleteGroup?treatmentId=' + treatmentId;
        return axios.delete(url);
    }
    static deleteCodedTreatmentById(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-coding-treatment/delete?id=' + id;
        return axios.delete(url)
    }
    static unDeleteCodedTreatmentById(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-coding-treatment/undelete?id=' + id;
        return axios.delete(url)
    }

    //

    static getInvoiceTypes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/szamlazz/assets/getInvoiceTypes';
        return axios.get(url);
    }
    static getAllInvoice(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/backoffice/invoice/listByPaging';
        return axios.get(url, params)
    }
    static getAllInvoiceTreatment(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/backoffice/invoice/treatment/listByPaging';
        return axios.get(url, params)
    }
    // Insurance partner
    static getAllInsurancePartner(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/backoffice/insurancePartner/listByPaging';
        return axios.get(url, params)
    }
    static saveInsurancePartner(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/backoffice/insurancePartner';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/backoffice/insurancePartner';
            return axios.post(url, params);
        }
    }
    static deleteInsurancePartner(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/backoffice/insurancePartner?id=' + id;
        return axios.delete(url);
    }
    static unDeleteInsurancePartner(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/backoffice/insurancePartner/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static listInsurancePartnerToSelect(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/backoffice/insurancePartner/selectByName';
        return axios.get(url, params)
    }
    ////////////////////

    // eDoc
    static getEDocList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-edoc/getDocumentList';
        return axios.post(url, params);
    }
    static downloadEDocFile(eDocId, attachmentId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-edoc/downloadFile';
        return axios.get(url, {
            params: {
                eDocId: eDocId,
                attachmentId: attachmentId
            }
        });
    }
    static getDocument(eDocId, attachmentId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-edoc/getDocument';
        return axios.get(url, {
            params: {
                eDocId: eDocId,
                attachmentId: attachmentId
            }
        });
    }

    ////////////////////

    // Várandóság
    static getPregnancyRisks() {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=50000';
        return axios.get(url);
    }
    static getPregnancyEvidences(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/varandossag-megallapitas/findByTreatmentId';
        return axios.get(url, params);
    }
    static printPregnancyEvidence(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/varandossag-megallapitas/print/' + id;
        return axios.get(url);
    }
    static savePregnancyForm(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/varandossag-megallapitas';
        return axios.post(url, params);
    }
    static updatePregnancyForm(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/varandossag-megallapitas';
        return axios.put(url, params);
    }
    static sendPregnancyFormToEESZT(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-esemenykatalogus/sendVarandosagEKatAndEHRDok?varandossagMegallapitasaId=' + id;
        return axios.post(url);
    }
    static deletePregnancyEvidence(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/varandossag-megallapitas?id=' + id;
        return axios.delete(url);
    }

    ////////////////////

    // Covid RAT
    static getAllCovidRat(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/covidRAT';
        return axios.get(url, params);
    }
    static saveCovidRat(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/covidRAT';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/covidRAT';
            return axios.post(url, params);
        }
    }
    static deleteCovidRat(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/covidRAT?id=' + id;
        return axios.delete(url);
    }
    static unDeleteCovidRat(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/covidRAT/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static importCovidRatFromEESZT(param) {
        const url = process.env.VUE_APP_BACKEND_URL + '/covidRAT/importFromXls';
        return axios.post(
            url,
            param,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    }
    ////////////////////

    // PUPHAX load
    static loadPuphaxNyilvantartas() {
        const url = process.env.VUE_APP_BACKEND_URL + '/puphax/getUpdatedRecords';
        return axios.get(url);
    }
    static getPuphaXLoaderProgressId() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eesztPuphaX/getPuphaXLoaderProgressId';
        return axios.get(url);
    }
    static getPuphaXLoaderStatus(progressId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eesztPuphaX/getPuphaXLoaderStatus';
        return axios.get(url, {
            params: {
                progressId: progressId
            }
        });
    }
    static getAllPuphaXLoaderLog() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eesztPuphaX/getAllPuphaXLoaderLog';
        return axios.get(url);
    }

    static getTermekkodList() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eesztPuphaX/getTermekkodList';
        return axios.get(url);
    }
    static getAllPuphaxTermek(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eesztPuphaX/listByPaging';
        return axios.get(url, params);
    }
    static getPuphaxEquivalentDrugs(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eesztPuphaX/getEquivalentDrugs';
        return axios.get(url, params);
    }
    static getPuphaxSupportGroupDrug(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eesztPuphaX/getSupportGroupDrug';
        return axios.get(url, params);
    }
    ////////////////////

    // EESZT TOR
    static getEuSzolg(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eesztTor/getEuSzolg';
        return axios.get(url, params);
    }
    static getEuSzolgEngedely(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eesztTor/getEuSzolgEngedely';
        return axios.get(url, params);
    }
    static getTorzs(entitasCsoportId, elemiEntitas) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eesztTor/getTorzs';
        return axios.get(url, {
            params: {
                entitasCsoportId: entitasCsoportId,
                elemiEntitas: elemiEntitas
            }
        });
    }
    static getNyilvantartas(entitasCsoportId, elemiEntitas) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eesztTor/getNyilvantartas';
        return axios.get(url, {
            params: {
                entitasCsoportId: entitasCsoportId,
                elemiEntitas: elemiEntitas
            }
        });
    }
    static getXsd(entitasCsoportId, elemiEntitas) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eesztTor/getXsd';
        return axios.get(url, {
            params: {
                entitasCsoportId: entitasCsoportId,
                elemiEntitas: elemiEntitas
            }
        });
    }
    static getObject(entitasCsoportId, elemiEntitas) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eesztTor/getObject';
        return axios.get(url, {
            params: {
                entitasCsoportId: entitasCsoportId,
                elemiEntitas: elemiEntitas
            }
        });
    }
    ////////////////////

    // EESZT report
    static getAllDoctorForEesztReport() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-report/getAllDoctorForEesztReport';
        return axios.get(url);
    }
    static getDoctorIdFromUser() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-report/getDoctorIdFromUser';
        return axios.get(url);
    }
    static listPatientEvidenceEesztError(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-report/listPatientEvidenceEesztError';
        return axios.get(url, params);
    }
    static listAllEesztReports(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eeszt-report/getAllEESZTUploads';
        return axios.get(url, params);
    }
    static printAllEesztReports(evidenceId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientEvidence/print/' + evidenceId;
        return axios.get(url);
    }
    static getPregnancyDetermination() {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientEvidence/canDeterminePregnancy';
        return axios.get(url);
    }
    ////////////////////

    // EESZT post submission
    static listEesztPostSubmissionEvidenceList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eesztPostSubmission/listEesztPostSubmissionEvidenceList';
        return axios.get(url, params);
    }
    static postSubmissionToEESZTEvidences(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/eesztPostSubmission/postSubmissionToEESZTEvidences';
        return axios.post(url, params);
    }
    static getEesztPostSubmissionEvidenceLog() {
        const url = process.env.VUE_APP_BACKEND_URL + '/eesztPostSubmission/getEesztPostSubmissionEvidenceLog';
        return axios.get(url);
    }
    ////////////////////

    // PCMS
    static getConsentHistoryUrl(patientId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/pcms/getConsentHistoryUrl'
        return axios.get(url, {
            params: {
                patientId: patientId
            }
        });
    }
    static getCreateConsentUrl(appointmentId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/pcms/getCreateConsentUrl'
        return axios.get(url, {
            params: {
                appointmentId: appointmentId
            }
        });
    }
    ////////////////////

    // TAJ érvényesség ellenőrzés

    /**
     * Taj érvényesség ellenőrzése
     * Lehetséges response:
     * "Z" - zöld - (érték esetén TAJ érvényes, jogviszonya rendezett),
     * "P" - piros - (érték esetén TAJ érvényes, jogviszonya rendezetlen),
     * "K" - kék - (érték esetén külföldön biztosított, a TAJ átmenetileg érvénytelen),
     * "N" - narancs - (érték esetén TAJ NAV járuléktartozás miatt érvénytelen)
     * "B" - barna - (érték esetén TAJ egyéb okból érvénytelen)
     * "S" - sárga - (Korlátozott ellátásra jogosult, érvényes TAJ)
     * @param taj
     * @returns {AxiosPromise<string>}
     */
    static getTajValidity(taj) {
        const url = process.env.VUE_APP_BACKEND_URL + `/ojote/check-taj?taj=${taj}`
        return axios.post(url);
    }

    ////////////////////


    // Appointment status
    static listAllAppointmentStatus() {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointmentStatus/listAllAppointmentStatus';
        return axios.get(url);
    }

    static saveAppointmentStatus(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/appointmentStatus';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/appointmentStatus';
            return axios.post(url, params);
        }
    }

    /**
     * Páciens partner/telephely/munkakör adatainak lekérése, mint string
     */
    static getAdditionalInfoForPatient(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient/getAdditionalInfoForPatient';
        return axios.get(url, params);
    }
    static getPartnerData(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/employabilitySickness/getPartnerData';
        return axios.get(url, params);
    }
    static saveNewPartnerToAppointment(params, appointmentId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient/changeAppointmentPartnerData?appointmentId=' + appointmentId;
        return axios.post(url, params);
    }

    /**
     * Partner telephelyek listájának lekérése rekurzív formában, gyerek telephelyekkel
     * @returns {AxiosPromise<any>}
     */
    static getSiteHierarchy(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partnerSite/getHierarchy';
        return axios.get(url, params);
    }

    // Cancelled Appointments
    static getAllCancelledAppointments(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/report/getNoShowReport';
        return axios.get(url, params);
    }
    static getAllCreatedBy() {
        const url = process.env.VUE_APP_BACKEND_URL + '/users/getAllUserLight';
        return axios.get(url);
    }

    // Új partnertelephelyek
    static saveNewEmployee(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroup/addPatient';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroup/addPatient';
            return axios.post(url, params);
        }
    }
    static getPartners(currentPage, perPage) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partner/getAllPartners?pageNumber=' + currentPage + '&pageSize=' + perPage;
        return axios.get(url);
    }
    static getFEUPartnersToSelect() {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partner/findAllVO';
        return axios.get(url);
    }

    static getSites(siteCurrentPage, sitePerPage, partnerId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partnerSite/getHierarchyByPartner?partnerId=' + partnerId + '&pageIndex=' + siteCurrentPage + '&pageSize=' + sitePerPage;
        return axios.get(url);
    }
    static findAllPatientsByPartnerSite(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroup/findAllPatientsByPartnerSite';
        return axios.get(url, params);
    }
    static findAllPatientsByPartnerSiteWithFilter(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroup/findAllPatientsByPartnerSiteWithFilter';
        return axios.get(url, params);
    }
    static listSelectPartnerSitesByPartner(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partnerSite/selectPartnerSitesByPartner';
        return axios.get(url, params)
    }
    static selectAllPartnerSitesByPartner(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partnerSite/selectAllPartnerSitesByPartner';
        return axios.get(url, params)
    }
    static findSitesHierarchyByPartner(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partnerSite/findSitesHierarchyByPartner';
        return axios.get(url, params)
    }
    static findAllPartnerSitesByPartnerId(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partnerSite/findAllPartnerSitesByPartnerId';
        return axios.get(url, params)
    }
    static findAllPartnerSitesByPartnerIdAndParentId(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partnerSite/findAllPartnerSitesByPartnerIdAndParentId';
        return axios.get(url, params)
    }
    static deleteOccupationHealthPartnerEmployee(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroupPatient/deleteSiteGroupPatient/' + id;
        return axios.delete(url);
    }
    static undeleteOccupationHealthPartnerEmployee(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroupPatient/undeleteSiteGroupPatient/' + id;
        return axios.delete(url);
    }
    static editBeforeUndeleteOccupationHealthPartnerEmployee(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroupPatient/undeleteAndUpdateSiteGroupPatient?id=' + params.id + '&employmentRelationshipEndDate=' + params.employmentRelationshipEndDate;
        return axios.post(url);
    }
    static getSupervisorsForEmployee(patientId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroupPatient/findSupervisorsForPatient/' + patientId;
        return axios.get(url);
    }
    static saveEmploymentClosureDate(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroupPatient/endEmploymentRelationship';
        return axios.put(url, params);
    }
    static changeEmployeeActivationStatus(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroup/changeEmployeeActivationStatus/' + id;
        return axios.put(url);
    }
    static filterPartners(filterParams, currentPage, perPage) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partner/filter?currentPage=' + currentPage + '&perPage=' + perPage;
        return axios.post(url, filterParams);
    }
    static filterPartnerSites(filterParams, currentPage, perPage) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partnerSite/filter?currentPage=' + currentPage + '&perPage=' + perPage
        return axios.post(url, filterParams);
    }
    static filterSites(filterParams) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/partnerSite/filter';
        return axios.post(url, filterParams);
    }
    static undeleteSiteContact(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteContact/setUnDelete?id=' + id;
        return axios.post(url);
    }

    //Discounts
    static saveNewDiscount(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/discount/modifyDiscount';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/discount/createDiscount';
            return axios.post(url, params);
        }
    }
    static getDiscounts(currentPage, perPage, withDeleted) {
        const url = process.env.VUE_APP_BACKEND_URL + '/discount/getAllDiscount?pageNumber=' + currentPage + '&pageSize=' + perPage + '&withDeleted=' + withDeleted;
        return axios.get(url);
    }
    static filterDiscounts(filterParams) {
        const url = process.env.VUE_APP_BACKEND_URL + '/discount/filter'
        return axios.post(url, filterParams);
    }
    static getTreatmentsForDiscount(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/discount/getTreatmentsForDiscount?id=' + id;
        return axios.get(url);
    }

    static getDiscountsTreatmentTypes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/discount/getTreatmentTypes';
        return axios.get(url);
    }

    static getInsurancePartners() {
        const url = process.env.VUE_APP_BACKEND_URL + '/discount/getInsurancePartners';
        return axios.get(url);
    }

    static getLabTypes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/discount/getLabTypes';
        return axios.get(url);
    }

    static deleteDiscount(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/discount/deleteDiscount?discountId=' + id;
        return axios.delete(url);
    }
    static undeleteDiscount(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/discount/undelete?id=' + id;
        return axios.delete(url);
    }
    static getDiscountsToSelect() {
        const url = process.env.VUE_APP_BACKEND_URL + '/discount/findAllVO';
        return axios.get(url);
    }

    //Packages
    //Fix packages
    static saveNewFixPackage(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/carePackageFixed/modify';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/carePackageFixed/save';
            return axios.post(url, params);
        }
    }
    static saveReservationFixPackage(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientXCarePackageFixed/save';
        return axios.post(url, params);
    }
    static getFixPackages(currentPage, perPage, withDeleted) {
        const url = process.env.VUE_APP_BACKEND_URL + '/carePackageFixed/getAll?pageNumber=' + currentPage + '&pageSize=' + perPage + '&withDeleted=' + withDeleted;
        return axios.get(url);
    }
    static getFixPackagesToCheckBoxes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/carePackageFixed/getAllToSelect';
        return axios.get(url);
    }
    static getTreatmentTypes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/carePackageFixed/getTreatmentTypes';
        return axios.get(url);
    }
    static deleteFixPackage(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/carePackageFixed/delete?id=' + id;
        return axios.delete(url);
    }
    static undeleteFixPackage(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/carePackageFixed/undelete?id=' + id;
        return axios.delete(url);
    }
    static filterFixPackages(filterParams) {
        const url = process.env.VUE_APP_BACKEND_URL + '/carePackageFixed/filter'
        return axios.post(url, filterParams);
    }
    //À la carte packages
    static saveNewALaCartePackage(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/carePackageAlaCarte/modify';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/carePackageAlaCarte/save';
            return axios.post(url, params);
        }
    }
    static saveReservationALaCartePackage(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientXCarePackageAlaCarte/save';
        return axios.post(url, params);
    }
    static getALaCartePackages(currentPage, perPage, withDeleted) {
        const url = process.env.VUE_APP_BACKEND_URL + '/carePackageAlaCarte/getAll?pageNumber=' + currentPage + '&pageSize=' + perPage + '&withDeleted=' + withDeleted;
        return axios.get(url);
    }
    static getALaCartePackagesToCheckBoxes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/carePackageAlaCarte/getAllToSelect';
        return axios.get(url);
    }
    static getFixedTreatments() {
        const url = process.env.VUE_APP_BACKEND_URL + '/carePackageAlaCarte/getFixedTreatments';
        return axios.get(url);
    }
    static getVariableTreatments() {
        const url = process.env.VUE_APP_BACKEND_URL + '/carePackageAlaCarte/getVariableTreatments';
        return axios.get(url);
    }
    static getAllTreatments() {
        const url = process.env.VUE_APP_BACKEND_URL + '/carePackageAlaCarte/getAllTreatmentTypes';
        return axios.get(url);
    }
    static deleteALaCartePackage(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/carePackageAlaCarte/delete?id=' + id;
        return axios.delete(url);
    }
    static undeleteALaCartePackage(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/carePackageAlaCarte/undelete?id=' + id;
        return axios.delete(url);
    }
    static filterALaCartePackages(filterParams) {
        const url = process.env.VUE_APP_BACKEND_URL + '/carePackageAlaCarte/filter'
        return axios.post(url, filterParams);
    }
    //Csomagok törlése pácienstől
    static getAllDeletablePackagesFromPatient(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientXPackage/listByPaging';
        return axios.get(url, params);
    }
    static deletePackageFromPatient(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientXPackage/delete?id=' + params.rowId + '&isFixedPackages=' + params.isFixedPackages;
        return axios.delete(url);
    }
    static undeletePackageFromPatient(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientXPackage/undelete?id=' + params.rowId + '&isFixedPackages=' + params.isFixedPackages;
        return axios.delete(url);
    }
    //Fogalási ablak: Csomagok
    static getAppointmentPackagesByPatient(params) {
        let url
        if (params.selectedPackageId) {
            url = process.env.VUE_APP_BACKEND_URL + '/patient/getPackagesForPatient?patientId=' + params.patientId + '&selectedPackageId=' + params.selectedPackageId;
        } else {
            url = process.env.VUE_APP_BACKEND_URL + '/patient/getPackagesForPatient?patientId=' + params.patientId;
        }
        return axios.get(url);
    }
    static getExpiredAppointmentPackagesByPatient(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient/getExpiredPackagesForPatient?patientId=' + id;
        return axios.get(url);
    }
    static getPackageTreatmentsByTreatmentId(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-coding-treatment/getPackageForTreatment'
        return axios.get(url, params);
    }
    //csomag törlése a foglalási ablakban
    static deleteAppointmentFixedPackage(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientXCarePackageFixed/delete?packageId=' + id;
        return axios.delete(url);
    }
    static deleteAppointmentAlaCartePackage(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientXCarePackageAlaCarte/delete?packageId=' + id;
        return axios.delete(url);
    }
    static getTreatmentsForAppointmentPackages(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient/getTreatmentTypesForPackage';
        return axios.get(url, { params: params })
    }
    static getTreatmentsForAppointmentPackagesWithPaging(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient/getTreatmentTypesForPackage/listByPaging';
        return axios.get(url, params);
    }
    static saveFixedAppointmentPackageTreatment(params) {
        let url
        if (params.oldTreatmentTypeId === null) {
            url = process.env.VUE_APP_BACKEND_URL + '/patientXCarePackageFixed/useTreatmentTypeFromPackage?assignedPackageId=' + params.assignedPackageId + '&treatmentTypeId=' + params.treatmentTypeId;
        } else if (params.oldTreatmentTypeId && params.oldPackageId) {
            url = process.env.VUE_APP_BACKEND_URL + '/patientXCarePackageFixed/useTreatmentTypeFromPackage?assignedPackageId=' + params.assignedPackageId + '&treatmentTypeId=' + params.treatmentTypeId + '&oldTreatmentTypeId=' + params.oldTreatmentTypeId + '&oldPackageId=' + params.oldPackageId;
        }
        else {
            url = process.env.VUE_APP_BACKEND_URL + '/patientXCarePackageFixed/useTreatmentTypeFromPackage?assignedPackageId=' + params.assignedPackageId + '&treatmentTypeId=' + params.treatmentTypeId + '&oldTreatmentTypeId=' + params.oldTreatmentTypeId;
        }
        return axios.put(url);
    }
    static saveAlaCarteAppointmentPackageTreatment(params) {
        let url
        if (params.oldTreatmentTypeId === null) {
            url = process.env.VUE_APP_BACKEND_URL + '/patientXCarePackageAlaCarte/useTreatmentTypeFromPackage?assignedPackageId=' + params.assignedPackageId + '&treatmentTypeId=' + params.treatmentTypeId;
        } else if (params.oldTreatmentTypeId && params.oldPackageId) {
            url = process.env.VUE_APP_BACKEND_URL + '/patientXCarePackageAlaCarte/useTreatmentTypeFromPackage?assignedPackageId=' + params.assignedPackageId + '&treatmentTypeId=' + params.treatmentTypeId + '&oldTreatmentTypeId=' + params.oldTreatmentTypeId + '&oldPackageId=' + params.oldPackageId;
        }
        else {
            url = process.env.VUE_APP_BACKEND_URL + '/patientXCarePackageAlaCarte/useTreatmentTypeFromPackage?assignedPackageId=' + params.assignedPackageId + '&treatmentTypeId=' + params.treatmentTypeId + '&oldTreatmentTypeId=' + params.oldTreatmentTypeId;
        }
        return axios.put(url);
    }
    //TODO: befejez: kész
    static getTreatmentTypeDataFromFixedPackage(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientXCarePackageFixed/getTreatmentTypeDataFromPackage?assignedPackageId=' + params.assignedPackageId + '&treatmentTypeId=' + params.treatmentTypeId;
        return axios.get(url);
    }
    static getTreatmentTypeDataFromAlaCartePackage(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientXCarePackageAlaCarte/getTreatmentTypeDataFromPackage?assignedPackageId=' + params.assignedPackageId + '&treatmentTypeId=' + params.treatmentTypeId;
        return axios.get(url);
    }
    static restoreFixedAppointmentPackageTreatment(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientXCarePackageFixed/restoreTreatmentType?id=' + params.assignedPackageId + '&treatmentTypeId=' + params.treatmentTypeId;
        return axios.put(url);
    }
    static restoreAlaCarteAppointmentPackageTreatment(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patientXCarePackageAlaCarte/restoreTreatmentType?id=' + params.assignedPackageId + '&treatmentTypeId=' + params.treatmentTypeId;
        return axios.put(url);
    }
    static restorePackageWithAppointmentId(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/restorePackageTreatmentTypeByAppointmentId?appointmentId=' + params.appointmentId;
        return axios.put(url);
    }
    //Belső beutalók
    static getAllPatientInternalReferral(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/internalReferral/listByPaging';
        return axios.get(url, params);
    }
    static getReferralInfoById(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/internalReferral/' + id;
        return axios.get(url);
    }
    static deleteInternalReferral(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/internalReferral/' + id;
        return axios.delete(url);
    }
    static unDeleteInternalReferral(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/internalReferral/restore/' + id;
        return axios.put(url);
    }
    static savePatientInternalReferral(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/internalReferral';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/internalReferral';
            return axios.post(url, params);
        }
    }
    //Richteres beutalók
    static getRichterTreatmentsByPatient(params) {
        let url
        if (params.params.richterRequestId) {
            url = process.env.VUE_APP_BACKEND_URL + '/treatmentType/getRichterTreatmentsByPatient?patientId=' + params.params.patientId + '&richterRequestId=' + params.params.richterRequestId;
        } else {
            url = process.env.VUE_APP_BACKEND_URL + '/treatmentType/getRichterTreatmentsByPatient?patientId=' + params.params.patientId
        }
        return axios.get(url);
    }
    //Betegellátás befejezése - email küldés
    static sendMolEmail(appointmentId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/treatment/sendMolEmail/' + appointmentId;
        return axios.post(url);
    }
    //Betegellátás befejezése - beutalók
    static getCreatedReferral(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/internalReferral/isCreatedForTreatment?treatmentId=' + params.treatmentId;
        return axios.get(url);
    }
    //Időpontfoglaló - beutalók
    static getAllAppointmentReferrals(params) {
        let url
        if (params.appointmentId) {
            url = process.env.VUE_APP_BACKEND_URL + '/internalReferral/getAllByPatient?patientId=' + params.patientId + '&appointmentId=' + params.appointmentId;
        } else {
            url = process.env.VUE_APP_BACKEND_URL + '/internalReferral/getAllByPatient?patientId=' + params.patientId;
        }
        return axios.get(url);
    }
    static saveReferralForAppointment(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/internalReferral/useReferral';
        return axios.put(url, params);
    }
    static connectReferralForAppointment(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/internalReferral/connectReferral';
        return axios.put(url, params);
    }
    static cancelReferralFromAppointment(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/internalReferral/cancelReferral';
        return axios.put(url, params);
    }
    static getExpiredAndUsedReferralsByPatient(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/internalReferral/getExpiredOrUsedForPatient?patientId=' + id;
        return axios.get(url);
    }
    // static getCreatedReferralDuringAppointment(params) {
    //     const url = process.env.VUE_APP_BACKEND_URL + '/internalReferral/getCreatedForPatient?appointmentId=' + params.appointmentId;
    //     return axios.get(url);
    // }
    static getCreatedReferralDuringAppointment(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/internalReferral/getCreatedForAppointment?appointmentId=' + params.appointmentId;
        return axios.get(url);
    }
    // Fizetettség
    static checkExistingCodingTreatments(appointmentId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/hasCodingTreatments?appointmentId=' + appointmentId;
        return axios.get(url);
    }

    //Új Biztosítók CRUD lenyíló gombal
    static saveNewInsurancePartner(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/backoffice/insurancePartner';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/backoffice/insurancePartner';
            return axios.post(url, params);
        }
    }
    static getInsurancePartnersBO(params, currentPage, perPage, withDeleted) {
        const url = process.env.VUE_APP_BACKEND_URL + '/backoffice/insurancePartner/listByPaging?pageNumber=' + currentPage + '&pageSize=' + perPage + '&withDeleted=' + withDeleted;
        return axios.post(url, params);
    }
    static getPackages(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/carePackageAlaCarte/getAllBothPackages';
        return axios.get(url, params);
    }
    static deleteInsurancePartnerBO(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/backoffice/insurancePartner?id=' + id;
        return axios.delete(url);
    }
    static unDeleteInsurancePartnerBO(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/backoffice/insurancePartner/setUnDelete?id=' + id;
        return axios.post(url);
    }
    static getDiscountsPagingFilterSort(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/backoffice/insurancePartner/getDiscountsPagingFilterSort';
        return axios.get(url, params);
    }
    static getInsurancePartnersToSelect() {
        const url = process.env.VUE_APP_BACKEND_URL + '/backoffice/insurancePartner/findAll';
        return axios.get(url);
    }
    static getInsurancePartnersToCheckboxes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/backoffice/insurancePartner/findAllVO';
        return axios.get(url);
    }

    static saveInsurancePartnerDescription(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/backoffice/insurancePartner';
        return axios.put(url, params);
    }

    //Contracts
    static saveNewContract(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/contracts/update';
            return axios.post(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/contracts/insert';
            return axios.put(url, params);
        }
    }
    static saveCopyContract(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/contracts/insert';
        return axios.put(url, params);
    }
    static getContracts(params, currentPage, perPage, withDeleted) {
        const url = process.env.VUE_APP_BACKEND_URL + '/contracts/listByPaging?pageNumber=' + currentPage + '&pageSize=' + perPage + '&withDeleted=' + withDeleted;
        return axios.post(url, params);
    }
    static deleteContract(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/contracts/delete?id=' + id;
        return axios.delete(url);
    }
    static deleteContractContact(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/contractContacts/delete?id=' + id;
        return axios.delete(url);
    }
    static unDeleteContact(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/contractContacts/undelete?id=' + id;
        return axios.delete(url);
    }
    static unDeleteContract(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/contracts/undelete?id=' + id;
        return axios.delete(url);
    }

    static getConractContactListByPaging(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/contractContacts/listByPaging';
        return axios.post(url, params)
    }
    static saveConractContact(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/contractContacts/update';
            return axios.post(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/contractContacts/insert';
            return axios.put(url, params)
        }

    }
    static saveNewPatientForContract(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/siteGroup/addPatient';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-contract/insert';
            return axios.put(url, params);
        }
    }
    static getPatientsForContract(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-contract/listByPaging';
        return axios.post(url, params);
    }

    static deleteContractPatient(contractId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-contract/delete?id=' + contractId;
        return axios.delete(url);
    }

    static saveContractDescription(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/contracts/update';
        return axios.post(url, params);
    }
    static listContractsToSelect() {
        const url = process.env.VUE_APP_BACKEND_URL + '/contracts/findAll';
        return axios.get(url);
    }
    static movePatientToNewContract(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-x-contract/update';
        return axios.post(url, params);
    }
    //Helyttesítés

    static saveSubstitueDoctor(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorCondultConfig/saveSubstitueDoctor';
        return axios.post(url, params);
    }
    static modifySubstitueDoctor(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorCondultConfig/modifySubstitution';
        return axios.put(url, params);
    }
    static deleteSubstitueDoctor(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/doctorCondultConfig/deleteSingleSubstitution?consultingHourId=' + id;
        return axios.post(url);
    }

    //Díjbekérők

    static getAllProformaInvoice(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/proFormaItem/listByPaging';
        return axios.get(url, params);
    }
    static deleteProformaInvoice(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/proFormaItem/delete?proFormaItemId=' + id;
        return axios.delete(url);
    }
    static unDeleteProformaInvoice(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/proFormaItem/undelete?proFormaItemId=' + id;
        return axios.get(url);
    }
    static saveProformaInvoice(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/proFormaItem/createProFormaItem';
        return axios.post(url, params);
    }
    static changeProformaInvoicePaymentStatus(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/proFormaItem/paymentStatus';
        return axios.post(url, params);
    }
    static sendProformaInvoiceEmail(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/proFormaItem/sendProFormaEmail';
        return axios.post(url, params);
    }
    static printProformaInvoiceDocument(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/proFormaItem/getProFormaDocument?proFormaId=' + id;
        return axios.get(url);
    }
    static setPaidStatusBack(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/proFormaItem/setUnpaid?id=' + id;
        return axios.get(url);
    }

    //Előlegszámla

    static createPrepaymentInvoice(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/proFormaItem/prePaymentInvoice';
        return axios.post(url, params);
    }
    static getAllPrepaymentInvoiceByCostumer(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/backoffice/invoice/getInvoicesByIds';
        return axios.post(url, params);
    }
    //Egyéb vizsgálati dokumentumok menü pont
    static getAdditionalExaminationListByPaging(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealth/labHandle/occHeaEvidenceListByPaging';
        return axios.get(url, params);

    }

    //Új számla kiállítás

    static getBillables(currentPage, perPage, filter) {
        const url = process.env.VUE_APP_BACKEND_URL + '/billable/listByPaging?pageIndex=' + currentPage + '&pageSize=' + perPage;
        return axios.post(url, filter)
    }

    static getAssets(rowDetails, currentModalPage, perModalPage) {
        const url = process.env.VUE_APP_BACKEND_URL + '/billable/liabilities?pageIndex=' + currentModalPage + '&pageSize=' + perModalPage;
        return axios.post(url, rowDetails)
    }

    static getInvoiceTreatmentsByMasterIds(params) {
        const url = process.env.VUE_APP_BACKEND_URL + "/billable/getBillablesByMasterIds";
        return axios.post(url, params)
    }
    static getTreatmentsCountIfFEUPartner(params) {
        const url = process.env.VUE_APP_BACKEND_URL + "/billable/transformBillablesForPartners";
        return axios.post(url, params)
    }
    static getFilteredDiscounts(params) {
        const url = process.env.VUE_APP_BACKEND_URL + "/discount/getToBillable";
        return axios.post(url, params)
    }
    static getDiscountsByTreatment(params) {
        const url = process.env.VUE_APP_BACKEND_URL + "/discount/getDiscountsByTreatment";
        return axios.post(url, params)
    }
    static getDiscountsWithoutFilterToLanogaSelect(params) {
        const url = process.env.VUE_APP_BACKEND_URL + "/discount/getDiscountsAllDiscounts";
        return axios.post(url, params)
    }

    //Egyéb kiállítható tételek

    static getOtherBillableItems(params) {
        const url = process.env.VUE_APP_BACKEND_URL + "/standardBillable/listByPaging";
        return axios.get(url, params)
    }

    static deleteOtherBillableItem(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/standardBillable/delete?id=' + id;
        return axios.delete(url);
    }

    static unDeleteOtherBillableItem(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/standardBillable/undelete?id=' + id;
        return axios.delete(url);
    }

    static saveOrUpdateOtherBillableItem(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/standardBillable/saveOrUpdate';
            return axios.post(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/standardBillable/saveOrUpdate';
            return axios.post(url, params);
        }
    }
    static getAllTeszorCodes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/standardBillable/getTesorCodes';
        return axios.get(url);
    }
    static linkStandardBillableToPatien(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/standardBillable/linkStandardBillableToPatient';
        return axios.post(url, params);
    }

    //Felkódolt egyéb számlázható tételek

    static getCodedOtherBillableItems(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/codedOtherItems/listByPaging';
        return axios.get(url, params)
    }

    static filterCodedOtherBillableItems(filterParams) {
        const url = process.env.VUE_APP_BACKEND_URL + '/codedOtherItems/filter'
        return axios.post(url, filterParams);
    }

    static deleteCodedOtherBillableItemsByPatient(masterId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/codedOtherItems/deleteGroup?id=' + masterId;
        return axios.delete(url)
    }

    static undeleteCodedOtherBillableItemsByPatient(masterId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/codedOtherItems/undeleteGroup?rowId=' + masterId;
        return axios.delete(url);
    }
    static deleteSingleOtherBillableItem(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/codedOtherItems/delete?id=' + id;
        return axios.delete(url)
    }

    static undeleteSingleOtherBillableItem(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/codedOtherItems/undelete?id=' + id;
        return axios.delete(url)
    }

    static getCodedOtherBillableItemsByRow(rowId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/codedOtherItems/getCodedTreatmentsForRow?rowId=' + rowId;
        return axios.get(url);
    }

    static getOtherBillableItemsForCheckboxes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/codedOtherItems/getTreatmentTypes';
        return axios.get(url);
    }

    // static getAllPackages(pageIndex, pageSize, filter) {
    //     const url = process.env.VUE_APP_BACKEND_URL + '/carePackageAlaCarte/getAllBothPackages?pageIndex=' + pageIndex + '&pageSize=' + pageSize + '&filter=' + filter;
    //     return axios.get(url);
    // }

    //Labortípusok

    static getAllLaboratoryTypes(params) {
        const url = process.env.VUE_APP_BACKEND_URL + "/labType/listByPaging";
        return axios.get(url, params)
    }

    static deleteLaboratoryType(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labType/delete?id=' + id;
        return axios.delete(url)
    }

    static unDeleteLaboratoryType(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labType/undelete?id=' + id;
        return axios.delete(url)
    }

    static saveOrUpdateLaborType(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/labType/modify';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/labType/create';
            return axios.post(url, params);
        }
    }

    static getLaboratoryExaminationTypes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/labType/getLabTypeTypes';
        return axios.get(url);
    }

    static getLaboratoryTypesPriceOfferPdf(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labType/createPriceOffer';
        return axios.post(url, params);
    }

    //Labortípus csomagok

    static getLaboratoryTypesPackages(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/synlabLabPackage/listByPaging';
        return axios.get(url, params)
    }

    static saveOrUpdateLaboratoryTypesPackage(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/synlabLabPackage/modify';
            return axios.put(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/synlabLabPackage/save';
            return axios.post(url, params);
        }
    }

    static deleteLaboratoryTypesPackage(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/synlabLabPackage/delete?id=' + id;
        return axios.delete(url)
    }

    static unDeleteLaboratoryTypesPackage(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/synlabLabPackage/undelete?id=' + id;
        return axios.delete(url)
    }

    //Labor

    static getRichterReferrals(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/getRichterReferralsForPatient'
        return axios.get(url, params);
    }
    static getAllRichterReferrals(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/richterReferral/listByPaging/'
        return axios.get(url, params);
    }
    static getRichterReferralDetails(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/richterReferral/examination'
        return axios.get(url, params);
    }

    static getRichterReferralLabTypeDataById(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/getRichterReferralLabTypeDataById'
        return axios.get(url, params);
    }
    static getBemDataForPatient(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/getBemDataForPatient'
        return axios.get(url, params);
    }
    static getRichterReferralLabPackageDataById(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/getRichterReferralLabPackageDataById'
        return axios.get(url, params);
    }
    static getLabCancelReasons() {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/getLabCancelReasons';
        return axios.get(url)
    }
    static getSampleTypes(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labType/getAllActiveSampleType';
        return axios.get(url, params)
    }
    static getTubeTypes() {
        const url = process.env.VUE_APP_BACKEND_URL + '/labType/getAllActiveTubeType';
        return axios.get(url)
    }
    static printSynlabEtikettSticker(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/printSynlabEtikettSticker?labId=' + id;
        return axios.get(url)
    }
    static printSynlabEtikettStickerAndSave(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/printSynlabEtikettStickerAndSave';
        return axios.post(url, params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    }
    static printSynlabEtikettStickerAndModify(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/printSynlabEtikettStickerAndModify';
        return axios.post(url, params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    }
    static getPatientLabById(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/getPatientLab?labId=' + id;
        return axios.get(url)
    }
    static getLaborResultsByLabId(labId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/laborResults?labId=' + labId;
        return axios.get(url)
    }
    static getCarcinogenicProtocolIds() {
        const url = process.env.VUE_APP_BACKEND_URL + '/synlabLabPackage/findCarcinogenicProtocolPackages';
        return axios.get(url)
    }
    static startCarcinogenicProtocol(labId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/startCarcinogenicProtocol/' + labId;
        return axios.post(url)
    }
    static getBillablesForLabs(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/billable/getBillablesForLabs';
        return axios.post(url, params)
    }
    static undeleteLab(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labHandle/undeleteLab';
        return axios.post(url, params)
    }

    //Labortípus-árlisták

    static getLabPriceLists(params, currentPage, perPage) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labPriceList/getDefaultPriceList?pageIndex=' + currentPage + '&pageSize=' + perPage;
        return axios.post(url, params)
    }
    static getLabPriceListsById(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labPriceList/getPriceListWithId?id=' + id;
        return axios.get(url)
    }
    static getAllLabPriceLists(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labPriceList/getAllPriceList';
        return axios.get(url, params)
    }
    static filterLabPriceLists(filterParams) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labPriceList/filter'
        return axios.post(url, filterParams);
    }
    static deleteLabPriceList(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labPriceList/delete?id=' + id;
        return axios.delete(url);
    }
    static undeleteLabPriceList(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labPriceList/undelete?id=' + id;
        return axios.delete(url);
    }
    static saveLabPriceLists(data) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labPriceList/save';
        return axios.post(url, data);
    }
    //Ütköző labor vizsgálatok
    static getConflictingLabTests(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labType/getAllActive';
        return axios.get(url, params)
    }
    static saveOrUpdateConflictingLabTests(params) {
        if (params.id) {
            const url = process.env.VUE_APP_BACKEND_URL + '/labType/updateConflict';
            return axios.post(url, params);
        } else {
            const url = process.env.VUE_APP_BACKEND_URL + '/labType/insertConflict';
            return axios.post(url, params);
        }
    }
    static deleteConflictingLabTests(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labType/deleteConflict?id=' + id;
        return axios.delete(url);
    }
    static unDeleteConflictingLabTests(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labType/unDeleteConflict?id=' + id;
        return axios.delete(url);
    }
    static isThereConflictingLabs(data) {
        const url = process.env.VUE_APP_BACKEND_URL + '/labType/checkConflict';
        return axios.post(url, data);
    }
    //Számlázás árfolyam
    static getExchangeRate() { //ep 
        const url = process.env.VUE_APP_BACKEND_URL + '/mnbcurrency/getActual';
        return axios.get(url);
    }
    static saveExchangeRate(params) { //ep 
        const url = process.env.VUE_APP_BACKEND_URL + '/mnbcurrency/saveCurrency';
        return axios.post(url, params)
    }
    //Dashboard

    static getDashboardData() {
        const url = process.env.VUE_APP_BACKEND_URL + '/dashboard';
        return axios.get(url);
    }
    static getDashboardDataLisByPaging(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/dashboard/listByPaging';
        return axios.get(url, params);
    }
    //employability sickness

    static getEmployabilitySicknessByPatient(params) {
        const patientId = params.params.filter.patientId;
        const url =
            process.env.VUE_APP_BACKEND_URL +
            "/employabilitySickness/listByPaging?id=" +
            patientId;
        return axios.get(url, params);
    }
    static getReportDoctorOptions() {
        const url = process.env.VUE_APP_BACKEND_URL + '/employabilitySickness/getReporter';
        return axios.get(url);
    }
    static getFinancialCapabilities() {
        const url = process.env.VUE_APP_BACKEND_URL + '/employabilitySickness/getFinancialCapabilities';
        return axios.get(url);
    }
    static getOccurenceOptions() {
        const url = process.env.VUE_APP_BACKEND_URL + '/employabilitySickness/getNatureOfOccurance';
        return axios.get(url);
    }
    static getDiagnoses() {
        const url = process.env.VUE_APP_BACKEND_URL + '/employabilitySickness/getDiagnoses';
        return axios.get(url);
    }
    static getPreviousEmployments(patientId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/employabilitySickness/getPreviousEmployments/' + patientId;
        return axios.get(url);
    }
    static getSicknessData(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/employabilitySickness/getSicknessData/' + id;
        return axios.get(url);
    }
    static getMedDocForCertificate(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medHealthCertificate/getMedDocForCertificate?healthCertificateId=' + id;
        return axios.get(url);
    }
    static validateEmployabilitySickness(sicknessId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/validateEmployabilitySickness?sicknessId=' + sicknessId;
        return axios.post(url);
    }
    static reOpenEmployabilitySickness(sicknessId, reOpenReason) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/reOpenEmployabilitySickness?sicknessId=' + sicknessId + '&reOpenReason=' + reOpenReason;
        return axios.post(url);
    }
    static rollbackEmployabilitySickness(documentId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/rollbackEmployabilitySickness?documentId=' + documentId;
        return axios.post(url);
    }
    static getAllEmployabilitySicknessHistory(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medDocument/getAllEmployabilitySicknessHistory';
        return axios.get(url, params);
    }
    static getIsTherePastEmployability(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/occupationHealthReport/occupationHealthEmployability/checkPatientExistingEmployability';
        return axios.get(url, params);
    }
    static findAllDraftEmployabilitySickness(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/employabilitySickness/findAllDraftEmployabilitySickness';
        return axios.get(url, params);
    }
    static getAppointmentObjectTreatments(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/getTreatmentForAppoinment/' + id;
        return axios.get(url);
    }
    static checkIfDoctorHasAppointmentFeuPartner(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/appointments/checkIfDoctorHasAppointmentFeuPartner/' + id;
        return axios.get(url);
    }
    static deleteEmployabilitySickness(id) {
        const url =
            process.env.VUE_APP_BACKEND_URL + "/employabilitySickness/delete?id=" + id;
        return axios.delete(url);
    }
    static unDeleteEmployabilitySickness(id) {
        const url =
            process.env.VUE_APP_BACKEND_URL + "/employabilitySickness/unDelete?id=" + id;
        return axios.delete(url);
    }
    static printEmployabilitySickness(id) {
        const url = process.env.VUE_APP_BACKEND_URL + "/employabilitySickness/print?id=" + id;
        return axios.get(url);
    }
    static printDraftEmployabilitySickness(id) {
        const url = process.env.VUE_APP_BACKEND_URL + "/employabilitySickness/printDraft?documentId=" + id;
        return axios.get(url);
    }
    static saveEmployabilitySickness(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/employabilitySickness/insert';
        return axios.post(url, params);
    }
    static updateEmployabilitySickness(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/employabilitySickness/update';
        return axios.put(url, params);
    }
    static saveAndValidateEmployabilitySickness(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/employabilitySickness/saveAndValidate';
        return axios.post(url, params);
    }
    static updateAndValidateEmployabilitySickness(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/employabilitySickness/updateAndValidate';
        return axios.put(url, params);
    }
    static getTitles(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/extended/30000';
        return axios.get(url, params);
    }
    //PACS
    static getPACSUrl(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/users/getPacsURL?userId=' + params.userId + '&patientSocialInsuranceNumber=' + params.patientSocialInsuranceNumber;
        return axios.get(url);
    }

    // Xls loader
    //Medicare árlista betöltő
    static getDownloadableSynlabPriceListTemplate() {
        const url = process.env.VUE_APP_BACKEND_URL + '/synlab-price-list-loader/downloadTemplate';
        return axios.get(url);
    }
    static validateSynlabPriceListXlsx(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/synlab-price-list-loader/validate';
        return axios.post(url, params);
    }
    static saveValidatedSynlabPriceListXlsx(params, queryParams) {
        const url = process.env.VUE_APP_BACKEND_URL + '/synlab-price-list-loader/xls?email=' + queryParams.email;
        return axios.post(url, params);
    }
    static getAllSynlabPriceListFiles(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/xlsLoader/listSynlabPriceListLoader';
        return axios.get(url, params);
    }
    //Páciens XLS feltöltő
    static validatePatientXls(params, partnerId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-loader/validateExcel?partnerId=' + partnerId;
        return axios.post(url, params);
    }
    static validateTreatmentTypeXls(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/treatment-type-xls-loader/validate';
        return axios.post(url, params);
    }
    static validateLaboratoryTypeXls(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/synlab-price-list-loader/validate';
        return axios.post(url, params);
    }
    static saveValidatedPatientXls(params, queryParams) {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-loader/updatePatients?partnerId=' + queryParams.partnerId + '&fullActiveList=' + queryParams.fullActiveList + '&email=' + queryParams.email;
        return axios.post(url, params);
    }
    static saveValidatedTreatmentTypeXls(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/treatment-type-xls-loader/updateTreatmentTypes';
        return axios.post(url, params);
    }
    static saveValidatedLaboratoryTypeXls(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/synlab-price-list-loader/xls';
        return axios.post(url, params);
    }
    static getDownloadableTemplate() {
        const url = process.env.VUE_APP_BACKEND_URL + '/patient-loader/downloadTemplate';
        return axios.get(url);
    }
    static getAllPatientXlsFiles(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/xlsLoader/listPatientLoader';
        return axios.get(url, params);
    }
    //Partner hierarchia feltöltő
    static getAllPartnerHierarchyXlsxFiles(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/xlsLoader/listPartnerLoader';
        return axios.get(url, params);
    }
    static validatePartnerHierarchyXlsx(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/hierarchy-xls-loader/validate';
        return axios.post(url, params);
    }
    static saveValidatedPartnerHierarchyXlsx(params, queryParams) {
        const url = process.env.VUE_APP_BACKEND_URL + '/hierarchy-xls-loader/xls?email=' + queryParams.email;
        return axios.post(url, params);
    }
    static getDownloadablePartnerHierarchyTemplate() {
        const url = process.env.VUE_APP_BACKEND_URL + '/hierarchy-xls-loader/downloadTemplate';
        return axios.get(url);
    }
    //Alkalmassági feltöltő
    static validateEmployabilityXls(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/employability-xls-loader/validate';
        return axios.post(url, params);
    }
    static saveValidatedEmployabilityXls(params, queryParams) {
        const url = process.env.VUE_APP_BACKEND_URL + '/employability-xls-loader/xls?email=' + queryParams.email;
        return axios.post(url, params);
    }
    static getDownloadableEmployabilityTemplate() {
        const url = process.env.VUE_APP_BACKEND_URL + '/employability-xls-loader/downloadTemplate';
        return axios.get(url);
    }
    static getAllEmployabilityImportXlsFiles(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/xlsLoader/listEmployabilityLoader';
        return axios.get(url, params);
    }
    //Törzsszám betöltő
    static getAllEmployeeIdImportXlsxFiles(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/xlsLoader/listEmployeeIdLoader';
        return axios.get(url, params);
    }
    static validateEmployeeIdXlsx(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/employee-id-xls-loader/validate';
        return axios.post(url, params);
    }
    static saveValidatedEmployeeIdXlsx(params, queryParams) {
        const url = process.env.VUE_APP_BACKEND_URL + '/employee-id-xls-loader/updateEmployeeId?email=' + queryParams.email;
        return axios.post(url, params);
    }
    static getDownloadableEmployeeIdTemplate() {
        const url = process.env.VUE_APP_BACKEND_URL + '/employee-id-xls-loader/downloadTemplate';
        return axios.get(url);
    }
    //Felettes betöltő
    static getAllSupervisorImportXlsxFiles(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/xlsLoader/listSupervisorLoader';
        return axios.get(url, params);
    }
    static validateSupervisorXlsx(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/supervisor-xls-loader/validate';
        return axios.post(url, params);
    }
    static saveValidatedSupervisorXlsx(params, queryParams) {
        const url = process.env.VUE_APP_BACKEND_URL + '/supervisor-xls-loader/xls?email=' + queryParams.email;
        return axios.post(url, params);
    }
    static getDownloadableSupervisorTemplate() {
        const url = process.env.VUE_APP_BACKEND_URL + '/supervisor-xls-loader/downloadTemplate';
        return axios.get(url);
    }
    //Nem használatban lévő endpointok (régi betöltő)
    static validateXlsFile(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/xlsLoader/validateXls';
        return axios.get(url, params);
    }

    static uploadXlsImportfile(param) {
        const url = process.env.VUE_APP_BACKEND_URL + '/xlsLoader';
        return axios.post(
            url,
            param,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    }
    static getXlsImportStatusList(params) {
        const url = process.env.VUE_APP_BACKEND_URL + '/cstore/bytype?csId=47000';
        return axios.get(url, params);
    }

    static loadXlsToDatabase(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/xlsLoader/loadXls?id=' + id;
        return axios.post(url);
    }

    static getXlsLog(param) {
        const url = process.env.VUE_APP_BACKEND_URL + '/xlsLoader/log/listByPaging';
        return axios.get(url, param);
    }

    static deleteImportedPatients(id) {
        const url = process.env.VUE_APP_BACKEND_URL + '/xlsLoader?id=' + id;
        return axios.delete(url);
    }
    static getXslLoaderStatus(progressId) {
        const url = process.env.VUE_APP_BACKEND_URL + '/xlsLoader/getXslLoaderStatus';
        return axios.get(url, {
            params: {
                progressId: progressId
            }
        });

    }
    // Páciens igazolások
    static createPatientHealthCertificate(data) {
        const url = process.env.VUE_APP_BACKEND_URL + '/medHealthCertificate';
        return axios.post(url, data);
    }
    /**
     * @param {*} certificateId - record id of the certificate
     * @param {*} data 
     */
    static updatePatientHealthCertificate(certificateId, data) {
        const url = process.env.VUE_APP_BACKEND_URL + `/medHealthCertificate/${certificateId}`;
        return axios.put(url, data);
    }
    /**
     * @param {*} certificateId - record id of the certificate
     */
    static validatePatientHealthCertificate(certificateId) {
        const url = process.env.VUE_APP_BACKEND_URL + `/medDocument/validateHealthCertificate?healthCertificateId=` + certificateId;
        return axios.post(url);
    }
    static getAllPatientHealthCertificateByPatientId(patientId, deleted) {
        const deletedQuery = deleted ? '1' : '0'
        const url = process.env.VUE_APP_BACKEND_URL + `/medHealthCertificate/patients/${patientId}/newest?deleted=${deletedQuery}`;
        return axios.get(url);
    }
    static deletePatientHealthCertificate(certificateId) {
        const url = process.env.VUE_APP_BACKEND_URL + `/medHealthCertificate/${certificateId}`;
        return axios.delete(url);
    }
    static restorePatientHealthCertificate(certificateId) {
        const url = process.env.VUE_APP_BACKEND_URL + `/medHealthCertificate/${certificateId}/restore`;
        return axios.put(url);
    }
    static rollbackPatientHealthCertificate(certificateId) {
        const url = process.env.VUE_APP_BACKEND_URL + `/medDocument/rollbackHealthCertificate?documentId=` + certificateId;
        return axios.post(url);
    }
    static reOpenPatientHealthCertificate(certificateId,reOpenreason) {
        const url = process.env.VUE_APP_BACKEND_URL + `/medDocument/reOpenHealthCertificate?healthCertificateId=` + certificateId + '&reOpenReason=' + reOpenreason;
        return axios.post(url);
    }
    static getPatientHealthCertificateHistory(certificateId, params) {
        const url = process.env.VUE_APP_BACKEND_URL + `/medDocument/getHealthCertificateHistory?healthCertificateId=` + certificateId;
        return axios.get(url, params);
    }
    static downloadPatientHealthCertificate(certificateId) {
        const url = process.env.VUE_APP_BACKEND_URL + `/medHealthCertificate/${certificateId}/print`;
        return axios.get(url);
    }
    static uploadPatientHealthCertificateToEeszt(certificateId) {
        const url = process.env.VUE_APP_BACKEND_URL + `/medHealthCertificate/${certificateId}/uploadToEeszt`;
        return axios.put(url);
    }
// Appointment modality
  static getAllAppointmentModality(params) {
    const url =
        process.env.VUE_APP_BACKEND_URL + "/roomDevice/findBySiteAndDoctorId";
    return axios.get(url, params);
  }

  static saveAppointmentModality(params) {
    const url = process.env.VUE_APP_BACKEND_URL + `/doctorCondultConfig/saveConsultingHourModality?consultingHourId=${params.consultingHourId}&modalityId=${params.modalityId}`;
    return axios.post(url);
  }

  static deleteAppointmentModality(params) {
    const url = process.env.VUE_APP_BACKEND_URL + `/doctorCondultConfig/deleteConsultingHourModality?consultingHourId=${params.consultingHourId}`;
    return axios.post(url);
  }

  static getModalityStatus(appointmentId) {
    const url = process.env.VUE_APP_BACKEND_URL + `/doctorCondultConfig/isModalityEnabled?appointmentId=${appointmentId}`;
    return axios.get(url);
  }

  static getMWLStatus(appointmentId) {
    const url = process.env.VUE_APP_BACKEND_URL + `/mwl/existByAppointmentId?appointmentId=${appointmentId}`;
    return axios.get(url);
  }

  static saveToMWL(appointmentId) {
    const url = process.env.VUE_APP_BACKEND_URL + `/mwl/saveToMwl?appointmentId=${appointmentId}`;
    return axios.post(url);
  }

  static deleteFromMWL(appointmentId) {
    const url = process.env.VUE_APP_BACKEND_URL + `/mwl/deleteFromMwl?appointmentId=${appointmentId}`;
    return axios.post(url);
  }

  //DeviceAndRoomAssignment
  static getAllRoomDevice(params) {
    const url = process.env.VUE_APP_BACKEND_URL + "/roomDevice/listByPaging";
    return axios.get(url, params);
  }
  static saveRoomDevice(params) {
    if (params.id) {
      const url = process.env.VUE_APP_BACKEND_URL + "/roomDevice";
      return axios.put(url, params);
    } else {
      const url = process.env.VUE_APP_BACKEND_URL + "/roomDevice";
      return axios.post(url, params);
    }
  }
  static deleteRoomDevice(id) {
    const url = process.env.VUE_APP_BACKEND_URL + "/roomDevice?id=" + id;
    return axios.delete(url);
  }
  static unDeleteRoomDevice(id) {
    const url =
        process.env.VUE_APP_BACKEND_URL + "/roomDevice/undelete?id=" + id;
    return axios.delete(url);
  }
  static getRoomDevices() {
    const url = process.env.VUE_APP_BACKEND_URL + "/cstore/bytype?csId=162000";
    return axios.get(url);
  }

  static getDoctorUtilizationListByPaging(params) {
    const url = process.env.VUE_APP_BACKEND_URL + "/report/doctorUtilizationListByPaging";
    return axios.post(url, params);
  }
  static exportDoctorUtilizationListByPaging(params) {
    const url = process.env.VUE_APP_BACKEND_URL + "/report/doctorUtilizationExport";
    return axios.post(url, params);
  }
  static getModalityOptions() {
    const url = process.env.VUE_APP_BACKEND_URL + "/cstore/bytype?csId=162000";
    return axios.get(url);
  }
  static findBySiteId(params) {
    const url =
      process.env.VUE_APP_BACKEND_URL + "/room/findBySiteId?siteId=" + params.params.siteId;
    return axios.get(url);
  }
}
